﻿/**
 * Spanish locale messages
 * Mirrors the structure of the English source of truth
 */

import { brand } from '../config/brand';

export default {
  // Controles y ventana del tiempo (CurrentWeather, WeatherModal, WeatherForecast)
  weather: {
    title: 'Tiempo actual',
    refresh: 'Actualizar el tiempo',
    updated: 'Actualizado',
    justNow: 'ahora mismo',
    feelsLike: 'Sensación térmica',
    humidity: 'Humedad',
    wind: 'Viento',
    pressure: 'Presión',
    clouds: 'Nubes',
    visibility: 'Visibilidad',
    sunrise: 'Amanecer',
    sunset: 'Atardecer',
    hourlyForecast: 'Pronóstico por horas',
    dailyForecast: 'Pronóstico diario',
    forecastTitle: 'Pronóstico del tiempo',
    hourly: 'Por horas',
    daily: 'Diario',
    today: 'Hoy',
    tomorrow: 'Mañana',
    unavailable: 'Los datos del tiempo aún no están disponibles.',
    forecastUnavailable: 'Pronóstico no disponible.',
    rainPercent: '{count}% de lluvia',
    noRain: 'Sin lluvia',
    configureInSettings: 'Configura el tiempo en Ajustes',
    loadFailed: 'No se pudieron cargar los datos del tiempo',
    alertsTitle: 'Alertas meteorológicas',
    now: 'Ahora',
    scrub: 'Recorre el pronóstico',
    sun: 'Sol',
    moon: 'Luna',
    moonrise: 'Salida de la luna',
    moonset: 'Puesta de la luna',
    illumination: 'iluminada',
    details: 'Detalles',
  },
  // Asistente para añadir habitaciones (AddRoomModal) - textos de interfaz
  roomWizard: {
    addRooms: 'Agregar habitaciones',
    buildingType: 'Tipo de edificio',
    selectDefaults: 'Seleccionar habitaciones predeterminadas para {type}',
    selectCommonRooms: 'Seleccionar habitaciones comunes',
    alreadyExists: 'Ya existe',
    floor: 'Planta {number}',
    addCustomRoom: 'Agregar habitación personalizada',
    roomName: 'Nombre de la habitación',
    roomNamePlaceholder: 'p. ej., Habitación de invitados, Bodega',
    floorNumber: 'Número de planta',
    floorNumberPlaceholder: '0, 1, 2...',
    addCustomRoomButton: 'Agregar habitación personalizada a la selección',
    areaAssignment: 'Asignación de área (opcional)',
    assignToArea: 'Asignar a área',
    noArea: 'Sin área',
    areaHelp: 'Todas las habitaciones seleccionadas se asignarán a esta área',
    selectedRooms: 'Habitaciones seleccionadas ({count})',
    clearAll: 'Borrar todo',
    cancel: 'Cancelar',
    creating: 'Creando...',
    createOne: 'Crear {count} habitación',
    createMany: 'Crear {count} habitaciones',
    searchIcons: 'Buscar iconos',
  },
  // Asistente para añadir habitaciones - tipos de edificio y habitaciones comunes
  roomPresets: {
    buildingTypes: {
      allRooms: 'Todas las habitaciones',
      home: 'Hogar',
      house: 'Casa',
      office: 'Oficina',
      school: 'Escuela',
      hotel: 'Hotel',
      hospital: 'Hospital',
    },
    rooms: {
      entrance_hall: 'Vestíbulo',
      living_room: 'Salón',
      dining_room: 'Comedor',
      kitchen: 'Cocina',
      pantry: 'Despensa',
      family_room: 'Sala familiar',
      study: 'Estudio',
      home_office: 'Oficina en casa',
      library: 'Biblioteca',
      master_bedroom: 'Dormitorio principal',
      bedroom: 'Dormitorio',
      bedroom_2: 'Dormitorio 2',
      bedroom_3: 'Dormitorio 3',
      bedroom_4: 'Dormitorio 4',
      guest_bedroom: 'Habitación de invitados',
      kids_room: 'Habitación infantil',
      master_bathroom: 'Baño principal',
      bathroom: 'Baño',
      powder_room: 'Aseo',
      laundry: 'Lavandería',
      garage: 'Garaje',
      workshop: 'Taller',
      storage: 'Trastero',
      utility_room: 'Cuarto de servicio',
      basement: 'Sótano',
      wine_cellar: 'Bodega',
      home_theater: 'Cine en casa',
      game_room: 'Sala de juegos',
      gym: 'Gimnasio',
      patio: 'Patio',
      balcony: 'Balcón',
      terrace: 'Terraza',
      garden: 'Jardín',
      pool_area: 'Zona de piscina',
      hallway: 'Pasillo',
      attic: 'Desván',
      reception: 'Recepción',
      office: 'Oficina',
      meeting_room: 'Sala de reuniones',
      conference_room: 'Sala de conferencias',
      break_room: 'Sala de descanso',
      restroom: 'Servicios',
      server_room: 'Sala de servidores',
      classroom: 'Aula',
      cafeteria: 'Cafetería',
      gymnasium: 'Polideportivo',
      laboratory: 'Laboratorio',
      playground: 'Parque infantil',
      lobby: 'Hall',
      guest_room: 'Habitación de invitados',
      suite: 'Suite',
      restaurant: 'Restaurante',
    },
  },
  // Common UI elements - buttons, actions, generic labels
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    remove: 'Quitar',
    close: 'Cerrar',
    back: 'Atrás',
    confirm: 'Confirmar',
    ok: 'Aceptar',
    loading: 'Cargando...',
    saving: 'Guardando...',
    error: 'Error',
    more: 'Más',
    copy: 'Copiar',
    all: 'Todos',
    language: 'Idioma',
    password: 'Contraseña',
  },

  // Cadenas de diálogos / cuadros de mensaje (confirmar, alerta, toast)
  dialogs: {
    // Genéricas
    areYouSure: '¿Estás seguro?',
    typeDelete: 'Escribe "DELETE"',
    finalWarning: 'ADVERTENCIA FINAL. Se eliminarán todos los datos. ¿Continuar?',
    done: 'Hecho',
    errorWithMessage: 'Error: {message}',
    saveFailed: 'Error al guardar los cambios',
    validationErrors: 'Corrige los siguientes errores:\n{errors}',
    deleteAllConversationHistory:
      '¿Seguro que quieres eliminar todo el historial de la conversación? Esta acción no se puede deshacer.',
    unregisterFromCloud: '¿Darte de baja de la nube? Se deshabilitará el acceso remoto.',
    removeUserAccess: '¿Eliminar el acceso de este usuario?',
    allDevicesDeleted: 'Todos los dispositivos eliminados',
    allRoomsDeleted: 'Todas las habitaciones eliminadas',
    allIntegrationsDeleted: 'Todas las integraciones eliminadas',
    allScenesDeleted: 'Todas las escenas eliminadas',
    factoryResetInitiated: 'Restablecimiento de fábrica iniciado.',
    // Dispositivo
    deviceDeleteConfirm: '¿Seguro que quieres eliminar "{name}"?\n\nEsta acción no se puede deshacer.',
    deviceDeleteConfirmShort: '¿Seguro que quieres eliminar este dispositivo?',
    deviceRemoveConfirm: '¿Seguro que quieres eliminar este dispositivo?',
    deviceDeleteFailed: 'Error al eliminar el dispositivo',
    devicesDeleteFailed: 'Error al eliminar los dispositivos',
    deviceDeleteFailedMessage: 'Error al eliminar el dispositivo: {message}',
    deviceDuplicateFailed: 'Error al duplicar el dispositivo: {message}',
    deviceReorderFailed: 'Error al actualizar el orden de los dispositivos',
    deviceReinitConfirm:
      'Esto eliminará y recreará todos los valores del dispositivo según la definición del tipo de dispositivo. Se conservarán los valores creados por el usuario. Se perderán las referencias (direcciones KNX, asignaciones Matter) y deberán reconfigurarse. ¿Continuar?',
    deviceReinitFailed: 'Error al reinicializar los valores del dispositivo',
    deviceRefsSaveFailed: 'Error al guardar las referencias',
    deviceRefsUpdateFailed: 'Algunas referencias no se pudieron actualizar:\n{errors}',
    customValueDeleteConfirm: '¿Eliminar el valor personalizado "{name}"?',
    thumbnailUploadFailed: 'Error al subir la miniatura del dispositivo: {message}',
    thumbnailRemoveFailed: 'Error al eliminar la miniatura del dispositivo: {message}',
    stateThumbnailUploadFailed: 'Error al subir la imagen de estado: {message}',
    stateThumbnailRemoveFailed: 'Error al eliminar la imagen de estado: {message}',
    deviceRoomUpdateFailed: 'Error al actualizar la habitación: {message}',
    // Widget / panel
    widgetDeleteConfirm: '¿Seguro que quieres eliminar este widget?',
    widgetMissing: 'Este widget ya no existe. Puede que se haya eliminado. La lista de widgets se actualizará.',
    widgetSaveFailed: 'Error al guardar: {message}',
    widgetRemoveConfirm: '¿Eliminar este widget del panel?',
    dashboardRebuildConfirm:
      '¿Reconstruir "{name}" como {label}? Los widgets existentes de esta página se reemplazarán.',
    dashboardDeleteConfirm: '¿Eliminar "{name}"? Esta acción no se puede deshacer.',
    dashboardGroupDeleteConfirm: '¿Eliminar el grupo "{name}"? Las páginas de este grupo quedarán sin agrupar.',
    dashboardGroupDeleteCountConfirm: '¿Eliminar el grupo "{name}"? {count} página(s) quedarán sin agrupar.',
    // Habitación
    roomExistsInDb: 'La habitación "{name}" ya existe en la base de datos.',
    roomAlreadyInSelection: 'La habitación "{name}" ya está en tu selección.',
    roomsCreateFailed: 'Error al crear las habitaciones',
    roomUpdateFailed: 'Error al actualizar la habitación',
    // Escena
    sceneCreateFailed: 'Error al crear la escena',
    sceneDeleteFailed: 'Error al eliminar la escena',
    sceneValuesSaveFailed: 'Error al guardar los valores de la escena',
    sceneThumbnailUploadFailed: 'Error al subir la miniatura',
    // Automatización
    automationCreateFailed: 'Error al crear la función',
    automationSaveFailed: 'Error al guardar la función',
    automationDeleteConfirm: '¿Seguro que quieres eliminar "{name}"?',
    automationDeleteFailed: 'Error al eliminar la función',
    automationDeleteFailedRetry: 'Error al eliminar la función. Inténtalo de nuevo.',
    // Calendario
    calendarDeleteConfirm: '¿Eliminar "{name}" y todos sus eventos?',
    calendarSaveChanges: '¿Quieres guardar los cambios?',
    calendarDiscardChanges: '¿Descartar los cambios sin guardar?',
    calendarDeleteEvent: '¿Eliminar "{title}"?',
    // Cámara / integración
    cameraDeleteRecording: '¿Eliminar esta grabación? Todos los segmentos se eliminarán de forma permanente.',
    cameraDeleteRecordingEvent:
      '¿Eliminar este evento de grabación? Todos los segmentos se eliminarán de forma permanente.',
    cameraDeleteConfirm: '¿Eliminar la cámara "{name}"? Todas las grabaciones se eliminarán de forma permanente.',
    cameraDeleteAllRecordings: '¿Eliminar TODAS las grabaciones de "{name}"? Esta acción no se puede deshacer.',
    cameraResetSettings: '¿Restablecer todos los ajustes de streaming a los valores predeterminados?',
    cameraToggleFailed: 'Error al cambiar la integración: {message}',
    cameraNameSaveFailed: 'Error al guardar el nombre: {message}',
    cameraSettingsSaved: 'Ajustes de cámara guardados correctamente',
    cameraSettingsSaveFailed: 'Error al guardar los ajustes de cámara: {message}',
    integrationConfigSaveFailed: 'Error al guardar la configuración: {message}',
    knxNoInterfaces:
      'No se encontraron interfaces IP KNX en la red. Asegúrate de que tu interfaz IP KNX esté encendida y conectada.',
    discoveryFailed: 'Error de descubrimiento: {message}',
    devicesAddFailed: 'Error al añadir algunos dispositivos: {message}',
    // Galería / imágenes
    imageDeleteConfirm: '¿Seguro que quieres eliminar esta imagen?',
    imageDeleteForEntity: '¿Eliminar la imagen de tipo {type} de {entity}?',
    imageReplaceForEntity: '¿Reemplazar la imagen de tipo {type} de {entity}?',
    fileTooLarge: 'El archivo es demasiado grande (máx. 50 MB)',
    fileDeleteConfirm: '¿Eliminar "{name}"?',
    fileDeleteFailed: 'Error al eliminar',
    albumAddFailed: 'Error al añadir al álbum',
    albumRemoveFailed: 'Error al quitar del álbum',
    albumSaveFailed: 'Error al guardar el álbum',
    albumDeleteConfirm: '¿Eliminar el álbum "{name}"? Las fotos no se eliminarán.',
    albumDeleteFailed: 'Error al eliminar el álbum',
    // Multimedia / notas
    mediaDeleteConfirm:
      '¿Eliminar "{title}" de la biblioteca multimedia? También se eliminará el archivo del servidor.',
    playlistDeleteConfirm: '¿Eliminar esta lista de reproducción?',
    zoneDeleteConfirm: '¿Eliminar esta zona? Se detendrá la reproducción y se eliminarán todos los miembros.',
    mediaPlayerRemoveConfirm: '¿Eliminar este reproductor multimedia?',
    coverPhotoUploadFailed: 'Error al subir la foto de portada',
    coverPhotoRemoveConfirm: '¿Eliminar esta foto de portada?',
    coverPhotoRemoveFailed: 'Error al eliminar la foto de portada',
    noteSaveFailed: 'Error al guardar la nota',
    noteDeleteConfirm: '¿Eliminar esta nota y todas sus imágenes?',
    noteDeleteFailed: 'Error al eliminar la nota',
    // Agente
    agentClearConversation: '¿Borrar esta conversación?',
    logoutConfirm: '¿Seguro que quieres cerrar sesión?',
    reminderDeleteConfirm: '¿Eliminar este recordatorio?',
    // Compras
    shoppingListSaveFailed: 'Error al guardar la lista',
    shoppingListDeleteConfirm: '¿Eliminar esta lista y todos sus artículos?',
    shoppingListDeleteFailed: 'Error al eliminar la lista',
    shoppingItemAddFailed: 'Error al añadir el artículo',
    shoppingClearCheckedConfirm: '¿Eliminar todos los artículos marcados?',
    shoppingClearFailed: 'Error al vaciar los artículos',
    shoppingStoreAddFailed: 'Error al añadir la tienda',
    shoppingStoreDeleteConfirm:
      '¿Eliminar esta tienda? Las listas se conservarán pero perderán la asociación a la tienda.',
    shoppingStoreDeleteFailed: 'Error al eliminar la tienda',
    // Integración (Matter / Z-Wave / Zigbee / monitorización)
    monitoringStartFailed: 'Error al iniciar la monitorización: {message}',
    monitorWriteFailed: 'Error al escribir: {message}',
    monitorReadFailed: 'Error al leer: {message}',
    mqttPropertyDeleteConfirm:
      '¿Eliminar esta propiedad MQTT? Se eliminarán las referencias de dispositivos existentes.',
    modbusRegisterDeleteConfirm:
      '¿Eliminar este registro Modbus? Se eliminarán las referencias de dispositivos existentes.',
    knxDatapointDeleteConfirm:
      '¿Eliminar esta dirección de grupo KNX? Se eliminarán las referencias de dispositivos existentes.',
    commissioningWindowFailed: 'Error al abrir la ventana de comisionamiento',
    matterDeviceUpdateFailed: 'Error al actualizar el dispositivo',
    matterDeviceSaveFailed: 'Error al guardar el dispositivo',
    matterDeleteFailed: 'Error al eliminar',
    matterError: '❌ Error: {message}',
    matterReinterviewConfirm:
      '¿Volver a entrevistar el nodo {id}? Esto eliminará y recreará todos los dispositivos de este nodo.',
    matterDecommissioned: '✅ Nodo Matter dado de baja y eliminado correctamente',
    matterNodeDeleteError: '❌ Error al eliminar el nodo: {message}',
    matterNodeRemoveTitle: 'Eliminar nodo Matter',
    matterNodeRemoveInspecting: 'Inspeccionando el nodo…',
    matterNodeRemoveDecommission: 'El controlador todavía tiene este nodo: primero se dará de baja y después se eliminarán sus filas.',
    matterNodeRemoveGhost: 'El controlador no tiene este nodo (se restableció su almacenamiento o el nodo se añadió a otro fabric). Sus filas se eliminarán sin contactar con el controlador.',
    matterNodeRemovePruneCounts: 'Filas a eliminar: {endpoints} punto(s) final(es), {clusters} clúster(es), {properties} fila(s) de atributos.',
    matterNodeRemoveControllerOffline: 'El controlador Matter no está en marcha, así que no se puede decidir entre dar de baja y podar. Inicie esta integración primero: el hub se niega a borrar filas que no puede comprobar.',
    matterNodeRemoveDevicesFlag: 'Eliminar también los {count} dispositivo(s) creados desde este nodo (lista abajo)',
    matterNodeRemoveDetach: '{count} dispositivo(s) de otra integración solo se desvincularán de este nodo, no se eliminarán.',
    matterNodeRemoveOtherIntegration: 'otra integración',
    matterNodeRemoveConfirm: 'Eliminar nodo',
    matterNodeRemoving: 'Eliminando…',
    matterNodeRemoved: '✅ Nodo eliminado: {endpoints} puntos finales, {clusters} clústeres, {properties} filas de atributos, {devices} dispositivo(s).',
    matterNodeGhostHint: 'No está en el controlador Matter: este nodo nunca se podrá controlar.',
    matterNodeRemoveAction: 'Eliminar',
    matterDiagnosticsFailed: 'Error al obtener los diagnósticos: {message}',
    matterFabricResetConfirm:
      '⚠️ ¿Restablecer el fabric de Matter?\n\nEsto:\n- Eliminará todo el almacenamiento y las credenciales de Matter\n- Generará un nuevo ID de fabric\n- Eliminará todos los dispositivos comisionados\n- Requerirá volver a comisionar todos los dispositivos\n\nEsta acción NO se puede deshacer. ¿Continuar?',
    matterFabricResetSuccess:
      '✅ ¡Restablecimiento del fabric correcto!\n\nEl controlador de Matter se reiniciará con un nuevo ID de fabric.\nActualiza la página en unos segundos.',
    matterFabricResetFailed: '❌ Error al restablecer el fabric: {message}',
    factoryResetFailed: 'Error al restablecer la configuración de fábrica',
    matterDeviceRemoveFailed: 'Error al eliminar el dispositivo',
    threadSaveFailed:
      'Error al guardar el conjunto de datos Thread. Es posible que la función no esté implementada en el hub todavía.',
    zigbeeGroupDeleteConfirm: '¿Eliminar el grupo {id}?',
    remoteSupportEndSessionFailed: 'Error al finalizar la sesión',
    remoteSupportSendMessageFailed: 'Error al enviar el mensaje',
    zigbeeNodeRemoveConfirm: '¿Eliminar el nodo {id}?',
    zwaveNodeRemoveConfirm: '¿Eliminar el nodo {id} de la base de datos?',
    zwaveNodeRenameFailed: 'Error al renombrar el nodo',
    zwaveEndpointRenameFailed: 'Error al renombrar el endpoint',
    wifiSaveFailed:
      'Error al guardar las credenciales WiFi. Es posible que la función no esté implementada en el hub todavía.',
    touchPanelUnpairConfirm: '¿Desvincular "{name}"? El dispositivo deberá volver a vincularse.',
    mapZoneDeleteConfirm: '¿Eliminar la zona "{name}"?',
    securityPinRemoveConfirm:
      '¿Eliminar el PIN de dispositivos secretos? Las cámaras secretas serán accesibles sin PIN.',
    // Ajustes
    scheduleEditorComingSoon:
      'El editor de horarios estará disponible pronto. Configura los horarios de los dispositivos mediante la API o la página de Energía.',
    libraryDeleteConfirm: '¿Eliminar este elemento?',
    securityModeDeleteConfirm: '¿Eliminar este modo de seguridad? Esta acción no se puede deshacer.',
    remoteSupportRemoveUserFailed: 'Error al eliminar el usuario',
    remoteSupportUpdateAccessFailed: 'Error al actualizar el acceso',
    // Usuario
    userSaveFailed: 'Error al guardar el usuario',
    userDeleteFailed: 'Error al eliminar el usuario: {message}',
    profilePictureRemoveConfirm: '¿Seguro que quieres eliminar tu foto de perfil?',
    // Servidores
    serverRemoveFromCloud: `¿Eliminar "{hub}" de ${brand.agentName} Cloud?\n\nAdvertencias:\n- Se eliminarán las entradas de acceso compartido de este servidor.\n- El servidor ${brand.agentName} local seguirá funcionando.\n- Para reaparecer en la nube, el servidor debe reconectarse y registrarse de nuevo.\n\nEsta acción no se puede deshacer.`,
    // Editor
    imageUrlMissing: 'La carga se realizó correctamente, pero no se devolvió ninguna URL de imagen.',
    imageUploadFailed: 'Error al subir la imagen',
  },

  // Authentication
  auth: {
    signIn: 'Iniciar sesión',
    emailAddress: 'Dirección de correo',
    passwordPlaceholder: 'Ingrese su contraseña',
    signInToYourHub: 'Inicie sesión en su hub',
    signInToOttoHome: `Iniciar sesión en ${brand.platformCompact}`,
    signingIn: 'Iniciando sesión...',
    invalidCredentials: 'Correo o contraseña inválidos',
    // No "Forgot password?" link on the sign-in form: the hub serves no
    // forgot/reset route any more (PLAN.md §4 phase 4, hub commit 51677c7),
    // so this sentence is the whole answer the form can honestly give.
    noPasswordReset:
      'No hay restablecimiento de contrase\u00f1a: este hub concede el acceso por invitaci\u00f3n, no por correo. Pide a un administrador que te invite o conecta este dispositivo desde la app.',
    genericError: 'Ocurrió un error. Por favor, intente de nuevo.',
    secureSmartHome: 'Acceso seguro a su hogar inteligente',
    usernameOrEmail: 'Nombre de usuario o correo',
    setupWizardTitle: 'Configura tu hub',
    setupWelcome: '¡Bienvenido! Prepararemos tu hub en unos pocos pasos.',
    setupStepSettingsTitle: 'Configuración del sistema',
    setupStepSettingsDesc: 'Pon nombre e imagen a tu hub para reconocerlo fácilmente.',
    setupStepCloudTitle: 'Registrarse en la nube (opcional)',
    setupStepCloudDesc:
      'Registrarte permite correo, notificaciones push y acceso remoto. Los servicios en la nube son de pago.',
    setupSystemNamePlaceholder: 'ej. Mi casa',
    setupUploadImage: 'Subir imagen',
    setupNext: 'Siguiente',
    setupBack: 'Atrás',
    setupFinish: 'Finalizar',
    setupSkip: 'Omitir',
    setupCloudPricing: 'Ver precios',
    setupCloudRegistered: 'Registrado en la nube',
  },

  // Navigation & Sidebar
  nav: {
    dashboard: 'Panel',
    home: 'Inicio',
    rooms: 'Habitaciones',
    devices: 'Dispositivos',
    cameras: 'Cámaras',
    security: 'Seguridad',
    climate: 'Clima',
    water: 'Agua',
    appliances: 'Electrodomésticos',
    wellness: 'Bienestar',
    lights: 'Luces',
    shades: 'Persianas',
    energy: 'Energía',
    weather: 'Tiempo',
    maintenance: 'Mantenimiento',
    apps: 'Apps',
    main: 'Principal',
    settings: 'Ajustes',
    media: 'Multimedia',
    intercom: 'Intercomunicador',
    map: 'Mapa',
  },

  roomsNav: {
    allRooms: 'Todas las habitaciones',
    unassigned: 'Sin asignar',
  },

  // Settings & System
  settings: {
    settingsUpdates: {
      hubUpdateTitle: 'Actualización del hub disponible',
      hubUpdateBody:
        'Hay una nueva actualización del hub: v{version}. Abre Ajustes → Sistema → Actualización del dispositivo para instalarla.',
      checkUpdates: 'Buscar actualizaciones',
      checking: 'Buscando...',
      updateFailed: 'Error en la actualización',
      downloadingUpdate: 'Descargando actualización...',
      updateReady: 'Actualización lista: reinicia para instalar',
      restartInstall: 'Reiniciar e instalar',
      upToDate: 'Estás en la última versión',
      appUpdate: 'Actualización de la app',
      checkFailed: 'No se pudo comprobar la actualización',
    },
    // Addon service cards (settings/AddonServicesSection.vue): the voice
    // services and the browser & automation addon the hub runs as containers.
    addons: {
      services: 'Servicios',
      refresh: 'Actualizar',
      noServices: 'No hay servicios disponibles.',
      status: {
        running: 'En ejecución',
        stopped: 'Detenido',
        notInstalled: 'No instalado',
        installing: 'Instalando',
        updating: 'Actualizando',
        uninstalling: 'Desinstalando',
        error: 'Error',
      },
      start: 'Iniciar',
      stop: 'Detener',
      install: 'Instalar',
      logs: 'Registros',
      logsTitle: 'Registros (últimas 100 líneas)',
      generateFromDevices: 'Generar desde dispositivos',
      generating: 'Generando...',
      availableCommands: 'Comandos disponibles',
      saveRestart: 'Guardar y reiniciar',
      savingRestart: 'Guardando y reiniciando...',
      savedRestarting: 'Guardado — el contenedor se está reiniciando',
      errorPrefix: 'Error:',
      errorLoad: 'No se pudieron cargar los servicios',
      errorSaving: 'Error al guardar la configuración',
      errorStart: 'No se pudo iniciar el servicio',
      errorStop: 'No se pudo detener el servicio',
      errorInstall: 'No se pudo instalar el servicio',
    },
  },

  // Settings Sidebar Navigation
  settingsNav: {
    configuration: 'Configuración',
    general: 'General',
    torikApi: 'Torik API',
    automations: 'Automatizaciones',
    rooms: 'Habitaciones',
    devices: 'Dispositivos',
    functions: 'Funciones',
    modes: 'Modos',
    integrations: 'Integraciones',
    security: 'Seguridad',
    energy: 'Energía',
    weather: 'Tiempo',
    climate: 'Clima',
    water: 'Agua',
    appliances: 'Electrodomésticos',
    lights: 'Luces',
    shades: 'Persianas',
    scenes: 'Escenas',
    routines: 'Rutinas',
    charts: 'Gráficos',
    system: 'Sistema',
    users: 'Usuarios',
    presence: 'Seguimiento de presencia',
    agent: 'Agente',
    demo: 'Demo',
    backup: 'Copia de seguridad',
    library: 'Biblioteca',
    dashboards: 'Paneles',
    gallery: 'Galería',
    model: 'Modelo 3D',
    installer: 'Instalador',
    logs: 'Registros',
    dangerZone: 'Zona de peligro',
  },

  // Views - Nested object for all view sections
  views: {
    // Map view (views/Map.vue + components/map/MapZonePanel.vue): the hub's own
    // geofence zones and the cloud areas the cloud owns (card `t_6b57f8f2`, plan
    // docs/plans/GEOFENCING-E2E.md §2.4). `cloudRefusal*` are read indirectly
    // (`cloudAreaRefusalNotice(...).key`) — see locales/localeAudit.ts.
    map: {
      title: 'Zonas de geovalla',
      empty: 'Aún no hay zonas. Crea una con «Añadir zona».',
      radiusMeters: 'Radio de {meters} m',
      flyTo: 'Ir a la zona',
      editZone: 'Editar zona',
      deleteZone: 'Eliminar zona',
      zoneName: 'Nombre de la zona',
      radiusShort: 'Radio (m)',
      radiusMetersLabel: 'Radio (metros)',
      lat: 'Latitud',
      lon: 'Longitud',
      newZone: 'Nueva zona',
      globalZone: 'Zona global (visible para todos los usuarios)',
      createZone: 'Crear zona',
      clickHint: 'Haz clic en el mapa para crear una nueva zona',
      addZone: 'Añadir zona',
      moveHint: 'Selecciona un área y arrastra su tirador para moverla',
      layerUsers: 'Usuarios',
      layerZones: 'Zonas',
      centerOnHub: 'Centrar en el hub',
      manageZones: 'Gestionar zonas',
      hubMarker: 'Hub',
      sourceLocal: 'En este servidor',
      sourceCloud: 'Área en la nube',
      cloudManaged: 'Gestionada en la nube',
      cloudTitle: 'Áreas en la nube',
      cloudAdd: 'Añadir área en la nube',
      cloudPickHint: 'Haz clic en el mapa para colocar la nueva área en la nube',
      cloudLoading: 'Cargando áreas en la nube…',
      cloudEmpty: 'Aún no hay áreas en la nube.',
      cloudRetry: 'Reintentar',
      cloudAdminOnly: 'Solo el propietario o un administrador del servidor puede cambiar sus áreas en la nube.',
      cloudAreaName: 'Nombre del área',
      cloudCreate: 'Crear área',
      cloudDeleteConfirm: '¿Eliminar el área en la nube "{name}"?',
      cloudRefusalForbidden: 'Esta cuenta no puede cambiar las áreas en la nube de este servidor.',
      cloudRefusalNotMember: 'Esta cuenta no tiene ningún rol en este servidor.',
      cloudRefusalNotAdmin: 'Solo el propietario o un administrador del servidor puede cambiar sus áreas en la nube.',
      cloudRefusalNotFound: 'Esta área en la nube ya no existe.',
      cloudRefusalInvalidRadius: 'El radio debe estar entre 50 y 5000 metros.',
      cloudRefusalInvalidArea: 'Revisa el nombre y la posición del área.',
      cloudRefusalGeneric: 'La nube rechazó el cambio.',
    },

    // Rooms view
    rooms: {
      pageTitle: 'Habitaciones',
      searchPlaceholder: 'Buscar por habitación o área...',
      loading: 'Cargando...',
      emptyTitle: 'No hay habitaciones',
      emptyDescription: 'Comience creando una nueva habitación.',
      noResultsTitle: 'No se encontraron habitaciones',
      noResultsDescription: 'Intente con un término de búsqueda diferente.',
      unassignedRoomsSectionTitle: 'Habitaciones no asignadas',
      loadError: 'Error al cargar los datos',
    },

    // Escaneo de habitaciones (tarjeta `t_90febbcf`, A2): el acceso y su panel
    // (`components/scan/RoomScanEntry.vue` + `RoomScanPanel.vue`). El escaneo lo
    // hace el plugin nativo `RoomScan` (iOS, LiDAR); `unsupported*` son las
    // respuestas honestas de un dispositivo sin LiDAR (plan §7).
    // Escaneos 3D (tarjeta `t_8ae1d20a`, E2): la página de ajustes que lista los
    // escaneos guardados en ESTE hub (`views/Settings/SettingsModel.vue`), con
    // subir, reemplazar, descargar y eliminar.
    model: {
      title: 'Modelo 3D',
      subtitle: 'El único modelo 3D de este hub y los escaneos con los que puede construirse.',
      homeTitle: 'Modelo 3D de la casa',
      homeIntro: 'Todas las páginas que muestran la casa dibujan estos bytes: hay un modelo por hub.',
      upload: 'Subir modelo…',
      replace: 'Reemplazar…',
      download: 'Descargar',
      delete: 'Eliminar',
      active: 'Activo',
      updated: 'Actualizado',
      loading: 'Leyendo el modelo…',
      loadFailed: 'No se pudo leer el modelo del hub',
      empty: 'Aún no hay un modelo 3D en este hub: sube un archivo IFC, GLB o glTF, o usa un escaneo 3D de abajo.',
      uploading: 'Subiendo el modelo…',
      uploadDone: 'El modelo se ha subido.',
      uploadFailed: 'No se pudo subir el modelo',
      badFormat: 'Elige un archivo IFC (.ifc), GLB (.glb) o glTF (.gltf).',
      tooLarge: 'El archivo del modelo debe ser menor de 200 MB.',
      downloading: 'Descargando el modelo…',
      downloadDone: 'El modelo se guardó como «{name}».',
      downloadFailed: 'No se pudo descargar el modelo',
      deleting: 'Quitando el modelo…',
      deleteTitle: 'Quitar el modelo 3D',
      deleteMessage:
        '¿Quitar el modelo 3D del hub «{name}»? Todas las páginas que muestran la casa lo pierden y la vista 3D queda vacía hasta que se suba otro modelo.',
      deleteDone: 'Se quitó «{name}».',
      deleteFailed: 'No se pudo eliminar el modelo',
      scanIsModel: '«{name}» es ahora el modelo 3D del hub.',
    },
    scans: {
      title: 'Escaneos 3D',
      subtitle: 'Escaneos de habitaciones guardados en este hub. Escanee una habitación con la cámara o suba un paquete de captura desde un teléfono.',
      scanRoom: 'Escanear una habitación',
      scanRoomHint: 'Un escaneo terminado se sube a este hub por sí solo.',
      uploadPackage: 'Subir paquete',
      refresh: 'Actualizar',
      hubTitle: 'En el hub',
      deviceTitle: 'Capturas en este dispositivo',
      deviceEmpty: 'Todavía no hay capturas en este dispositivo.',
      deviceOnHub: 'En el hub',
      deviceUpload: 'Subir',
      loading: 'Cargando escaneos…',
      loadFailed: 'No se pudieron cargar los escaneos de este hub',
      emptyTitle: 'Todavía no hay escaneos: escanee su primera habitación',
      emptyHint:
        'Un paquete de escaneo es la carpeta que escribe una captura (scan.json, model.usdz, el plano…). Suba uno aquí o escanee con la aplicación.',
      modeRoom: 'Una habitación',
      modeStructure: 'Planta',
      rooms: '{count} habitación | {count} habitaciones',
      files: '{count} archivo | {count} archivos',
      capturedAt: 'Capturado',
      updatedAt: 'Actualizado',
      download: 'Descargar',
      replace: 'Reemplazar',
      delete: 'Eliminar',
      close: 'Cerrar',
      retry: 'Intentar de nuevo',
      working: 'Trabajando…',
      reading: 'Leyendo la captura de este dispositivo…',
      uploading: 'Subiendo al hub…',
      replacing: 'Reemplazando en el hub…',
      downloading: 'Descargando del hub…',
      progress: '{percent} % subido',
      progressUnknown: 'El hub está recibiendo el paquete…',
      uploadDone: '"{name}" está en el hub.',
      replaceDone: '"{name}" se reemplazó.',
      deleteDone: '"{name}" se eliminó del hub.',
      downloadDone: '"{name}" guardado — {count} archivo | "{name}" guardado — {count} archivos',
      deleteTitle: '¿Eliminar este escaneo?',
      deleteMessage: '¿Eliminar "{name}" del hub? Sus archivos se eliminan con él y esto no se puede deshacer.',
      validationTitle: 'Este paquete no se envió',
      replaceTitle: 'Reemplazar "{name}"',
      replaceHint: 'El nuevo paquete ocupa el lugar del escaneo: los archivos actuales se eliminan.',
      replaceChooseCapture: 'Una captura en este dispositivo',
      replaceChooseFiles: 'Elegir archivos de este dispositivo…',
      replaceNoCaptures: 'No hay capturas en este dispositivo.',
      replaceUseCapture: 'Usar esta captura',
      invalid: {
        empty: 'Elija primero los archivos de un paquete de captura.',
        tooManyFiles: 'Un paquete lleva como máximo {max} archivos.',
        fileTooLarge: '"{name}" es mayor que {max} MB.',
        packageTooLarge: 'El paquete es mayor que {max} MB.',
        badFileName: '"{name}" no se puede guardar: un nombre de paquete no tiene ruta, no empieza por punto y no termina en punto ni espacio.',
        duplicateName: '"{name}" está dos veces en el paquete.',
        missingUsdz: 'El paquete necesita la geometría de la habitación: un archivo .usdz.',
        badScanDoc: 'El scan.json no es un documento torik.scan/v0.',
        generic: 'El paquete no se puede enviar tal cual.',
      },
      warnings: {
        missingScanDoc: 'No hay scan.json en el paquete: el hub lo guarda como captura a nivel de habitación.',
      },
      errors: {
        noHub: 'Este hub no se puede alcanzar ahora mismo.',
        auth: 'El hub rechazó esta sesión: inicie sesión de nuevo.',
        validation: 'El hub rechazó el paquete.',
        readFailed: 'No se pudo leer la captura en este dispositivo.',
        uploadFailed: 'La subida no terminó.',
        downloadFailed: 'La descarga no terminó.',
        saveFailed: 'El archivo no se pudo guardar en este dispositivo.',
        unknown: 'La transferencia no terminó.',
      },
      model: {
        title: 'Escanear en 3D',
        intro: 'Escanea una habitación con la cámara: la captura terminada se sube sola a este hub y cualquier escaneo puede convertirse en el modelo 3D de la casa en este hub.',
        scan3d: 'Escanear en 3D',
        empty: 'Aún no hay escaneos en este hub: empieza con «Escanear en 3D».',
        useScan: 'Usar como modelo',
        selected: 'Elegido como modelo',
        noModel: 'Este paquete no trae archivo de modelo',
        loadingFile: 'Leyendo el escaneo del hub…',
        attaching: 'Añadiendo el escaneo como modelo 3D del hub…',
        fetchFailed: 'No se pudo leer el escaneo del hub',
        attachFailed: 'El escaneo no pudo convertirse en el modelo 3D del hub',
      },
    },

    roomScan: {
      entryTitle: 'Escanear habitaciones con la cámara',
      entry: 'Escanear',
      title: 'Escaneo de habitaciones',
      checking: 'Comprobando si este dispositivo puede escanear…',
      unsupportedTitle: 'Este dispositivo no puede escanear habitaciones',
      unsupportedLidar: 'RoomPlan necesita un iPhone Pro o un iPad Pro: el escáner LiDAR es lo que mide la habitación.',
      unsupportedPlatform: 'El escaneo de habitaciones funciona en la app Torik en un iPhone Pro o iPad Pro (LiDAR).',
      errorTitle: 'El escaneo no terminó',
      nameLabel: 'Nombre de este escaneo (opcional)',
      namePlaceholder: 'p. ej. Salón',
      startRoom: 'Escanear una habitación',
      startStructure: 'Escanear una planta completa',
      startHint: 'La vista de cámara te guía: muévete despacio y mantén la habitación iluminada.',
      capturingRoom: 'Escaneando la habitación…',
      capturingRoomFloor: 'Escaneando esta habitación de la planta…',
      capturingHint: 'Recorre la habitación y pulsa Listo en la vista de cámara.',
      structureRooms: 'Habitaciones escaneadas: {count}',
      structureHint: 'Cada «Listo» guarda una habitación; «Finalizar» las une en un solo modelo.',
      scanAnother: 'Escanear otra habitación',
      finish: 'Finalizar',
      saved: 'Guardado: {label} · {count} habitación | Guardado: {label} · {count} habitaciones',
      scanFile: 'Datos del modelo',
      capturesTitle: 'En este dispositivo',
      capturesEmpty: 'Aún no hay escaneos en este dispositivo.',
      modeRoom: 'Una habitación',
      modeStructure: 'Planta',
      rooms: '{count} habitación | {count} habitaciones',
      deleteConfirm: '¿Eliminar el escaneo «{label}»? Hasta que exista la subida, solo existe en este dispositivo.',
    },

    // Devices view
    devices: {
      pageTitle: 'Dispositivos',
      searchPlaceholder: 'Buscar dispositivos...',
      groupByRooms: 'Habitaciones',
      groupByTypes: 'Tipos',
      loading: 'Cargando dispositivos...',
      noResultsTitle: 'No se encontraron dispositivos',
      noResultsDescription: 'Intente con un término de búsqueda diferente.',
      emptyTitle: 'No hay dispositivos',
      emptyDescription: 'Comience agregando un nuevo dispositivo.',
      noRoomLabel: 'Sin habitación',
      noRoomsWithDevicesTitle: 'No hay habitaciones con dispositivos',
      noRoomsWithDevicesDescription: 'Agregue dispositivos y asígnelos a habitaciones para verlos organizados aquí.',
      unknownType: 'Tipo desconocido',
      emptyTypeViewDescription: 'Agregue dispositivos para verlos organizados por tipo.',
      deleteConfirmTitle: 'Eliminar dispositivo',
      deleteConfirmMessage: '¿Está seguro de que desea eliminar {deviceName}?',
      cancelButton: 'Cancelar',
      deleteButton: 'Eliminar',
      deletingButton: 'Eliminando...',
      loadError: 'Error al cargar los datos',
    },

    // Scenes view
    scenes: {
      pageTitle: 'Escenas',
      searchPlaceholder: 'Buscar escenas...',
      addSceneButton: 'Agregar escena',
      reorderButton: 'Reordenar',
      doneButton: 'Listo',
      cancelButton: 'Cancelar',
      deleteButton: 'Eliminar',
      loading: 'Cargando',
      emptyTitle: 'Aún no hay escenas',
      emptyDescription: 'Cree una escena para comenzar.',
      noResultsTitle: 'No hay escenas que coincidan',
      deleteConfirmTitle: 'Eliminar escena',
      deleteConfirmMessage: '¿Está seguro de que desea eliminar',
      loadError: 'Error al cargar las escenas',
      executionSuccess: 'Escena ejecutada exitosamente',
      executionError: 'Ejecución completada con errores',
    },

    // Routines view
    routines: {
      pageTitle: 'Rutinas',
      loading: 'Cargando rutinas...',
      createButton: 'Crear rutina',
      editButton: 'Editar',
      runNowButton: 'Ejecutar ahora',
      emptyTitle: 'Aún no hay rutinas',
      emptyDescription: 'Cree su primera rutina para automatizar su hogar inteligente',
      triggerCount: 'disparador | disparadores',
      conditionCount: 'condición | condiciones',
      actionCount: 'acción | acciones',
      deleteConfirmMessage: '¿Está seguro de que desea eliminar esta rutina?',
      loadError: 'Error al cargar las rutinas',
      deleteError: 'Error al eliminar la rutina',
      enabledMessage: 'Rutina activada',
      disabledMessage: 'Rutina desactivada',
      deletedMessage: 'Rutina eliminada',
      executionStartedMessage: 'Ejecución de rutina iniciada',
      executionError: 'Error al ejecutar la rutina',
    },

    // Media view
    media: {
      audioZonesTitle: 'Zonas de audio',
      newZoneButton: 'Nueva zona',
      createZoneTitle: 'Crear zona',
      noAudioZonesTitle: 'Aún no hay zonas de audio',
      noAudioZonesDescription: 'Cree una zona y añada paneles o aplicaciones.',
      pausedLabel: 'Pausado',
      noMediaPlayersTitle: 'No hay reproductores multimedia',
      noMediaPlayersDescription: 'Agregue una integración multimedia para descubrir reproductores.',
      goToIntegrations: 'Ir a Integraciones',
      noLocalMediaMessage: 'Aún no hay contenido multimedia en la biblioteca.',
    },

    // Cameras view
    cameras: {
      pageTitle: 'Cámaras',
      liveTab: 'En vivo',
      playbackTab: 'Reproducción',
      onlineLabel: 'en línea',
      intercomLabel: 'intercomunicador',
      unlockSecretCamerasTitle: 'Ingrese el PIN para ver las cámaras secretas',
      secretButton: 'Secreto',
      editButton: 'Editar',
      doneButton: 'Listo',
      secretCameraTitle: 'Cámara secreta - oculta de los invitados',
      loading: 'Cargando cámaras...',
      noCamerasFoundMessage: 'No se encontraron cámaras. Agregue cámaras en la configuración de Integraciones.',
      refreshSnapshotTitle: 'Actualizar instantánea',
      privacyBlurTitle: 'Desenfoque de privacidad',
      privacyBlurMenuTitle: 'Duración del desenfoque',
      blur5Min: '5 minutos',
      blur15Min: '15 minutos',
      blur30Min: '30 minutos',
      blur1Hour: '1 hora',
      blur2Hours: '2 horas',
      removeBlurButton: 'Quitar desenfoque',
      muteMotionNotificationsTitle: 'Silenciar notificaciones de movimiento',
      muteMotionNotificationsMenuTitle: 'Silenciar notificaciones de movimiento durante',
      unmuteMotionNotificationsButton: 'Activar notificaciones de movimiento',
      intercomBadge: 'Intercomunicador',
      callDoorphoneTitle: 'Llamar portero electrónico',
      editModeInstructions: 'Use las flechas para reordenar · Haga clic en el candado para marcar como secreto',
      cancelButton: 'Cancelar',
      savingButton: 'Guardando...',
      saveOrderButton: 'Guardar orden',
      selectCamerasMessage: 'Seleccione las cámaras arriba para iniciar la reproducción',
      // Una vista en directo cuyo ICE nunca se completa: la respuesta WHEP de la
      // cámara se aceptó y no se estableció ninguna ruta de medios.
      // `services/mediaPath.ts` acota la espera y nombra el estado; los
      // reproductores muestran esta frase (tarjeta t_20b35b28).
      mediaPathFailed:
        'No se pudo establecer la ruta de medios hacia esta cámara — aceptó la solicitud, pero no se estableció ninguna conexión de vídeo o audio. Inténtalo de nuevo, abre la aplicación propia de la cámara o consulta el registro de go2rtc en el hub.',
      // Por qué terminó el intento, bajo la frase (tarjeta t_4d5b3263): las tres
      // causas exigen pasos distintos, y en pantalla solo aparece la causa — el
      // recuento de candidatos y los tiempos se quedan en la consola y en los
      // avisos de `services/mediaPath.ts`.
      mediaPathReasonBudget:
        'Ninguna ruta de red hacia la cámara llegó a completarse — la causa suele estar en la red del hub, no en la cámara.',
      mediaPathReasonFailed: 'La ruta de red hacia la cámara ha fallado — revisa la red del hub antes de reintentar.',
      mediaPathReasonNoCandidates: 'Este dispositivo no pudo preparar una conexión con la cámara.',
    },

    // Account view
    account: {
      profileInformationTitle: 'Información del perfil',
      profilePictureLabel: 'Foto de perfil',
      changePictureButton: 'Cambiar foto',
      pictureFormatHint: 'PNG o JPG (máx. 2 MB)',
      fullNameLabel: 'Nombre completo',
      fullNamePlaceholder: 'Ingrese su nombre completo',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: "usuario{'@'}ejemplo.com",
      phoneLabel: 'Número de teléfono',
      phonePlaceholder: '+34 (6) 12 34 56 78',
      bioLabel: 'Biografía',
      bioPlaceholder: 'Cuéntenos sobre usted',
      saveProfileButton: 'Guardar perfil',
      savingButton: 'Guardando...',
      securitySettingsTitle: 'Configuración de seguridad',
      changePasswordTitle: 'Cambiar contraseña',
      currentPasswordLabel: 'Contraseña actual',
      currentPasswordPlaceholder: 'Ingrese la contraseña actual',
      newPasswordLabel: 'Nueva contraseña',
      newPasswordPlaceholder: 'Ingrese la nueva contraseña',
      confirmPasswordLabel: 'Confirmar nueva contraseña',
      confirmPasswordPlaceholder: 'Confirme la nueva contraseña',
      updatePasswordButton: 'Actualizar contraseña',
      updatingButton: 'Actualizando...',
      currentDeviceLabel: 'Dispositivo actual',
      thisBrowserLabel: 'Este navegador',
      preferencesTitle: 'Preferencias',
      themeLabel: 'Tema',
      languageLabel: 'Idioma',
      notificationsTitle: 'Notificaciones',
      savePreferencesButton: 'Guardar preferencias',
      memberSinceLabel: 'Miembro desde',
      lastLoginLabel: 'Último inicio de sesión',
      sessionTitle: 'Sesión',
      logoutDescription: 'Cierre su sesión actual.',
      allFieldsRequired: 'Todos los campos son obligatorios',
      passwordMinLengthError: 'La contraseña debe tener al menos 8 caracteres',
      passwordsMismatchError: 'Las contraseñas no coinciden',
      profileTabLabel: 'Perfil',
      securityTabLabel: 'Seguridad',
      preferencesTabLabel: 'Preferencias',
      infoTabLabel: 'Info',
      themeSystemDefault: 'Predeterminado del sistema',
      themeLightOption: 'Claro',
      themeDarkOption: 'Oscuro',
      languageEnglish: 'English',
      languageSpanish: 'Español',
      languageFrench: 'Français',
      languageGerman: 'Deutsch',
      languageItalian: 'Italiano',
      languageSlovenian: 'Slovenščina',
      temperatureUnitsLabel: 'Unidades de temperatura',
      celsiusOption: 'Celsius (°C)',
      fahrenheitOption: 'Fahrenheit (°F)',
      notificationGroupAlerts: 'Alertas',
      notificationGroupAlertsDetail: 'Alertas de dispositivos y problemas del hub',
      notificationGroupAutomation: 'Automatización y avisos',
      notificationGroupAutomationDetail: 'Automatizaciones, rutinas, temporizadores y recordatorios',
      notificationGroupMessages: 'Llamadas y mensajes',
      notificationGroupMessagesDetail: 'Llamadas y mensajes de chat',
      notificationGroupPartly: 'Parcialmente activado',
      notificationGroupsUnavailable: 'No se pudo cargar la configuración de notificaciones.',
      userNotifications: {
        typeDeviceAlert: 'Alertas de dispositivos',
        typeSystem: 'Problemas del hub',
        typeAutomation: 'Automatizaciones',
        typeRoutine: 'Rutinas',
        typeInfo: 'Avisos',
        typeCall: 'Llamadas',
        typeChat: 'Mensajes de chat',
        channelPush: 'Push',
        channelInApp: 'En la app',
        unavailable: 'No se pudo cargar la configuración de notificaciones de esta persona.',
      },
      accountInformationTitle: 'Información de la cuenta',
      logOutButton: 'Cerrar sesión',
      loggingOutButton: 'Cerrando sesión...',
      notSetLabel: 'No establecido',
      roleLabel: 'Rol',
      userRoleDefault: 'Usuario',
      activeLabel: 'Activo',
      otherSessionsHint: 'Otras sesiones activas aparecerán aquí',
    },

    // Notifications view
    notifications: {
      title: 'Notificaciones',
      markAllAsRead: 'Marcar todo como leído',
      clearAll: 'Borrar todo',
      tabAll: 'Todas las notificaciones',
      tabUnread: 'No leídas',
      tabByType: 'Por tipo',
      loading: 'Cargando notificaciones...',
      emptyState: 'Aún no hay notificaciones',
      emptyUnread: '¡Todo al día! No hay notificaciones no leídas',
      noNotificationsOfType: 'No hay notificaciones de este tipo',
      markAsUnread: 'Marcar como no leída',
      markAsRead: 'Marcar como leída',
      deleteButton: 'Eliminar',
      deleteAllConfirm: '¿Eliminar todas las notificaciones?',
      timeJustNow: 'Justo ahora',
      timeMinutesAgo: 'min',
      timeHoursAgo: 'h',
      timeDaysAgo: 'd',
    },

    // Alarms view
    alarms: {
      title: 'Alarmas',
      newAlarm: 'Nueva alarma',
      emptyState: 'Aún no hay alarmas. Toque Nueva alarma para comenzar.',
      editAlarmTitle: 'Editar alarma',
      labelField: 'Etiqueta',
      labelPlaceholder: 'Despertar',
      timeField: 'Hora',
      repeatField: 'Repetición',
      noDaysHelp: 'Ningún día seleccionado = alarma única',
      snoozeField: 'Duración de repetición (minutos)',
      soundField: 'Sonido',
      cancel: 'Cancelar',
      saveAlarm: 'Guardar alarma',
      saving: 'Guardando...',
      confirmDelete: '¿Eliminar esta alarma?',
      daysSu: 'Do',
      daysMo: 'Lu',
      daysTu: 'Ma',
      daysWe: 'Mi',
      daysTh: 'Ju',
      daysFr: 'Vi',
      daysSa: 'Sá',
    },

    // People view
    people: {
      title: 'Personas',
      searchPlaceholder: 'Buscar conversaciones...',
      loading: 'Cargando...',
      emptyPeople: 'No se encontraron personas',
      selfDMDescription: 'Guardar mensajes, archivos y enlaces',
      selfBadge: 'Yo',
      selfConversationHint: 'Solo usted puede ver esto',
      participantsLabel: 'participantes',
      audioCallTitle: 'Llamada de audio',
      videoCallTitle: 'Llamada de video',
      moreOptionsTitle: 'Más opciones',
      deleteAllMessages: 'Eliminar todos los mensajes',
      captionPlaceholder: 'Añadir un pie de foto (opcional)...',
      messagePlaceholder: 'Escriba un mensaje...',
      someoneTyping: 'Alguien está escribiendo...',
    },

    // Areas view

    // Integrations view
    integrations: {
      title: 'Integraciones',
      addIntegration: 'Agregar integración',
      loading: 'Cargando integraciones...',
      emptyTitle: 'No hay integraciones',
      emptyMessage: 'Comience agregando una nueva integración.',
      delete: 'Eliminar',
      deleteTitle: 'Eliminar integración',
      confirmDeletePrefix: '¿Está seguro de que desea eliminar',
      confirmDeleteSuffix: ' ? Esto también eliminará todos los dispositivos asociados.',
      cancel: 'Cancelar',
      deleting: 'Eliminando...',
      statusDisabled: 'Desactivada',
      statusConnected: 'Conectada',
      statusDisconnected: 'Desconectada',
      statusDemo: 'Demo',
      demoMode: 'Modo demo',
      demoModeOn: 'Demo activado',
      demoModeSaving: 'Guardando...',
      demoModeTooltip:
        'Modo demo: esta integración está desconectada del hardware real y proporciona valores simulados. Desactívelo para reconectar de verdad.',
      demoModeHint: 'Simular esta integración — sin tráfico hacia el dispositivo o bus real.',
      demoModeActiveHint: 'Funciona con valores simulados (controlador demo). No se contacta con ningún hardware.',
    },

    // Agent view
    agent: {
      title: `${brand.agentName}`,
      subtitle: 'Asistente de voz y texto',
      reset: 'Restablecer',
      resetTitle: 'Restablecer si el agente está atascado',
      clearButton: 'Borrar',
      history: 'Historial',
      emptyTitle: '¿Cómo puedo ayudarle?',
      emptyMessage: 'Intente pedirme que controle dispositivos, verifique el estado o gestione su hogar',
      thinking: 'Pensando...',
      stop: 'Detener',
      listeningIndicator: '🎤 Escuchando... Hable ahora',
      placeholder: 'Escriba un mensaje o use la voz...',
      noHistory: 'Aún no hay historial de conversaciones',
      suggestionLights: 'Encender las luces de la sala de estar',
      suggestionTemperature: '¿Cuál es la temperatura?',
      suggestionCameras: 'Muéstrame las cámaras',
      suggestionScene: 'Ejecutar escena de buenas noches',
    },

    // Room view
    room: {
      floorLabel: 'Piso',
      addDevice: 'Agregar dispositivo',
      editRoom: 'Editar habitación',
      moreActions: 'Más acciones',
      emptyTitle: 'No hay dispositivos en esta habitación',
      emptyMessage: 'Haga clic en "Agregar dispositivo" para añadir uno a esta habitación.',
      scenesSection: 'Escenas',
      chartsSection: 'Gráficos',
      deleteTitle: 'Eliminar dispositivo',
      confirmDeletePrefix: '¿Está seguro de que desea eliminar',
      confirmDeleteSuffix: ' ?',
      cancel: 'Cancelar',
      deleting: 'Eliminando...',
      devicesSection: 'Dispositivos',
      editLayout: 'Editar diseño',
      done: 'Listo',
      editHint:
        'Arrastre los dispositivos para reordenarlos. Use la barra de herramientas de cada dispositivo para elegir cómo se muestra.',
      dragToReorder: 'Arrastrar para reordenar',
      deviceSettings: 'Configuración del dispositivo',
      displayAuto: 'Auto',
      displayButton: 'Botón',
      displayFull: 'Ancho completo',
      displayIcon: 'Icono',
      addScene: 'Añadir escena',
      reorderScenes: 'Reordenar escenas',
      reorder: 'Reordenar',
      dragScenesToReorder: 'Arrastra las escenas para reordenarlas',
      layout: 'Diseño',
      layoutImageAlt: 'Diseño de {room}',
      dragHandle: 'arrastrar',
      otherType: 'Otro',
    },

    dashboardNew: {
      actionsMenuTitle: 'Acciones del panel',
      addDashboardAction: 'Agregar panel',
      addWidgetAction: 'Agregar widget',
      editDashboardAction: 'Editar panel',
      toggleEditModeAction: 'Alternar modo edición',
      gridSettingsAction: 'Configuración de cuadrícula',
      loadingMessage: 'Cargando panel...',
      retryButton: 'Reintentar',
      defaultDashboardName: 'Panel',
      welcomeHeading: `Bienvenido a ${brand.platformCompact}`,
      welcomeDescription: 'Comience creando su primer panel desde una plantilla o desde cero.',
      createDashboardButton: 'Crear panel',
    },

    // Settings views
    settingsSystem: {
      title: 'Ajustes del sistema',
      systemName: 'Nombre del sistema',
      systemNamePlaceholder: `${brand.platformCompact}`,
      systemImage: 'Imagen del sistema',
      changeImage: 'Cambiar imagen',
      uploadImage: 'Subir imagen',
      removeImage: 'Eliminar',
      imageSizeLimit: 'PNG, JPG o WebP (máx. 5 MB)',
      imageTooLarge: 'El archivo de imagen es demasiado grande (máx. 10MB)',
      imageUploaded: 'Imagen subida exitosamente',
      imageRemoved: 'Imagen eliminada correctamente',
      saveSystemSettings: 'Guardar ajustes del sistema',
      savingSystem: 'Guardando...',
      cloudServices: 'Servicios en la nube',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      connecting: 'Conectando...',
      connectionError: 'Error de conexión',
      notRegistered: 'No registrado',
      registerCloudDescription:
        'Registre su hub con servicios en la nube para habilitar acceso remoto y uso compartido.',
      cloudAccount: 'Cuenta en la nube',
      cloudAccountEmail: 'Correo de la cuenta en la nube',
      emailPlaceholder: "email{'@'}example.com",
      cloudUrl: 'URL de la nube',
      registerWithCloud: 'Registrar en la nube',
      registering: 'Registrando...',
      reconnect: 'Reconectar',
      reconnecting: 'Reconectando...',
      unregister: 'Desregistrar',
      unregistering: 'Desregistrando...',
      sharedWith: 'Compartido con',
      hubNotShared: 'Este hub no está compartido con nadie más.',
      removeAccess: 'Eliminar',
      viewOnly: 'Solo vista',
      control: 'Control',
      admin: 'Admin',
      emailToSharePlaceholder: "usuario{'@'}example.com",
      add: 'Agregar',
      adding: 'Agregando...',
      loading: 'Cargando...',
      saving: 'Guardando...',
      settingsSaved: 'Ajustes guardados correctamente',
      hubLocation: 'Ubicación del hub',
      locationDescription:
        'La ubicación del hub se utiliza para pronósticos meteorológicos y cálculos de amanecer/atardecer.',
      automaticLocation: 'Automático',
      manual: 'Manual',
      pickLocation: 'Seleccionar ubicación en el mapa',
      latitude: 'Latitud',
      latitudePlaceholder: 'p. ej., 46.1199',
      longitude: 'Longitud',
      longitudePlaceholder: 'p. ej., 14.4992',
      elevation: 'Elevación (metros)',
      elevationPlaceholder: 'p. ej., 500',
      location: 'Ubicación',
      saveHubLocation: 'Guardar ubicación del hub',
      weather: 'Clima',
      weatherLocation: 'Ubicación del clima',
      searchCityPlaceholder: 'Ingrese el nombre de la ciudad',
      units: 'Unidades',
      metric: 'Métrico (°C, m/s)',
      imperial: 'Imperial (°F, mph)',
      saveWeatherSettings: 'Guardar ajustes de clima',
      cityRequired: 'La ciudad es obligatoria',
      weatherSettingsSaved: 'Ajustes de clima guardados',
      citySearchFailed: 'No se pudieron buscar ciudades',
      searchCity: 'Buscar ciudad',
      enterCityName: 'Ingrese el nombre de la ciudad',
      searching: 'Buscando...',
      search: 'Buscar',
      noCitiesFound: 'No se encontraron ciudades',
      enterCitySearch: 'Ingrese al menos 2 caracteres para buscar',
      close: 'Cerrar',
      checkForUpdates: 'Buscar actualizaciones',
      checking: 'Buscando...',
      confirmInstall: '¿Instalar actualización? El sistema se reiniciará.',
      confirmRollback: '¿Revertir versión? El sistema se reiniciará.',
      installUpdate: 'Instalar actualización',
      installing: 'Instalando...',
      systemUpdates: 'Actualizaciones del sistema',
      securityUpdateTooltip: 'Actualización de seguridad',
      currentVersionLabel: 'Versión actual',
      channelLabel: 'Canal',
      lastCheckedLabel: 'Última comprobación',
      updateAvailableLabel: 'Actualización disponible',
      lastUpdatedLabel: 'Última actualización',
      kernelLabel: 'kernel',
      checkingForUpdates: 'Buscando actualizaciones...',
      applianceUpdateHint:
        'Haga clic en Buscar actualizaciones para comprobar si hay nuevas versiones del dispositivo.',
      platformdUpToDate: 'El demonio de la plataforma está actualizado.',
      platformdNoUpdate: 'No hay actualización disponible para el demonio de la plataforma.',
      platformdUpdateHint:
        'Haga clic en Buscar actualizaciones para comprobar las versiones del demonio de la plataforma.',
      systemUpdatesDisabled: 'Las actualizaciones del sistema no están habilitadas en este dispositivo.',
      platformdUpdate: 'Demonio de la plataforma',
      platformdUpdateDescription:
        'Servicio del sistema que gestiona la red, el hardware y las actualizaciones del dispositivo',
      installPlatformd: 'Actualizar el demonio de la plataforma',
      confirmInstallPlatformd: '¿Actualizar el demonio de la plataforma? El servicio se reiniciará brevemente.',
      platformdUpdateInProgress:
        'Actualización del demonio de la plataforma en curso — el servicio se reiniciará al finalizar.',
      licence: 'Licencia',
      manageLicence: 'Gestionar licencia',
      noPlan: 'Sin plan',
      unlimitedSeats: 'Puestos ilimitados',
      oneSeat: '1 puesto',
      seats: 'puestos',
      ownerOnly: 'Solo el propietario',
      accessLocalOnly: 'Solo acceso local',
      accessRemote: 'Acceso remoto',
      licensedApps: 'Aplicaciones',
      licenceNeedsRegistration: 'Registre este servidor arriba para recibir su licencia desde la nube.',
      licencePending: 'Esperando a que la nube confirme la licencia de este servidor — se actualiza solo en un minuto.',
      licenceStale: 'Sin confirmar recientemente',
      licenceStaleHint:
        'La nube no ha confirmado esta licencia desde hace un tiempo — compruebe la conexión de arriba.',
      licenceGrantedTo: 'Concedida a',
      licenceConfirmed: 'Última confirmación desde la nube',
      justNow: 'justo ahora',
      minutesAgo: 'minutos atrás',
      hourAgo: 'hora atrás',
      hoursAgo: 'horas atrás',
      systemIcon: 'Icono del sistema',
      systemIconType: 'Tipo de icono',
      systemIconGenerated: 'Generado automáticamente',
      systemIconCustom: 'Imagen personalizada',
      systemIconColor: 'Color de fondo',
      systemIconTextColor: 'Color del texto',
      systemIconUpload: 'Subir icono',
      systemIconPreview: 'Vista previa',
      systemIconSizeLimit: 'Solo PNG (máx. 500KB)',
      systemIconSaved: 'Ajustes del icono del sistema guardados',
      saveSystemIconSettings: 'Guardar ajustes del icono del sistema',
      systemIconReset: 'Restablecer valores predeterminados',
      systemIconResetConfirm: '¿Restablecer el icono del sistema a los valores predeterminados?',
      systemIconResetDone: 'Icono del sistema restablecido',
      applianceUpdate: 'Actualización del dispositivo',
      applianceUpdateDescription: `Actualizaciones del software del hub ${brand.agentName} y de los paquetes del sistema`,
      confirmInstallSystem:
        '¿Instalar todas las actualizaciones de paquetes del sistema? Puede tardar varios minutos. El sistema seguirá funcionando.',
      installAll: 'Instalar todas las actualizaciones',
      rollback: 'Volver a la versión anterior',
      rollingBack: 'Revirtiendo...',
      upToDate: 'El sistema está actualizado',
      updateInProgress: 'Actualización en curso — el hub se reiniciará al finalizar.',
      updateCheckFailed: 'Error al buscar actualizaciones del dispositivo.',
      updateStatusInProgress: 'Hay una actualización en curso.',
      updateInstalling: 'Se está instalando la actualización — el hub se reiniciará al finalizar.',
      updateStatusInstalling: 'Se está instalando la actualización — el hub se reiniciará al finalizar.',
      updateStatusNotRegistered:
        'Se requiere el registro en la nube para que este hub pueda buscar versiones del dispositivo.',
      updateStatusBlocked:
        'Este hub necesita una actualización intermedia antes de poder instalar la última versión del dispositivo.',
      updateStatusNoRelease: 'Actualmente no hay ninguna versión publicada del dispositivo disponible para este canal.',
      updateStatusUpToDate: 'Este hub ya está en la última versión publicada del dispositivo.',
      updateStatusUnreachable: 'No se pudo contactar con el servicio de actualizaciones.',
      updateStatusNoUpdate: 'Actualmente no hay ninguna actualización del dispositivo disponible.',
      updateStarted: 'Actualización iniciada. El hub se reiniciará si se instala una nueva versión del dispositivo.',
      updateStartFailed: 'No se pudo iniciar la actualización del dispositivo.',
      rollbackInitiated: 'Reversión iniciada. El hub se reiniciará si hay una imagen de reversión disponible.',
      rollbackStartFailed: 'No se pudo iniciar la reversión.',
      systemUpdateCheckFailed: 'No se pudieron comprobar las actualizaciones del sistema',
      systemInstallFailed: 'Error de instalación',
    },

    settingsUsers: {
      usersManagement: 'Personas y dispositivos',
      peopleSectionTitle: 'Personas',
      peopleSectionHint:
        'Todos los que tienen un rol en este hub. Una persona inicia sesión con su cuenta Torik — no hay contraseña local.',
      peopleEmpty: 'Aún no hay nadie en este hub. Invita a la primera persona por correo.',
      serverOwnerRow: 'Propietario de este servidor',
      accountLinked: 'Vinculado a {email}',
      accountNotLinkedWithEmail: 'Aún sin cuenta vinculada — {email}',
      accountNotLinked: 'Aún sin cuenta vinculada',
      inviteDescription:
        'Envía una invitación por correo. La persona la acepta con su sesión de Torik — sin contraseña y sin código.',
      inviteRoleHint: 'Obtendrán el rol {role} en este hub.',
      addUser: 'Agregar usuario',
      usersLoading: 'Cargando usuarios...',
      done: 'Hecho',
      passwordNotAvailable:
        'Esta cuenta inicia sesión con su cuenta Torik o una invitación — no tiene contraseña local.',
      editPersonTitle: 'Editar persona',
      deviceListTitle: 'Dispositivos conectados',
      deviceLastSeen: 'Visto por última vez {date}',
    },

    settingsBackup: {
      title: 'Copia de seguridad y restauración',
      automaticBackupSettings: 'Configuración de copias automáticas',
      createBackup: 'Crear copia de seguridad',
      creatingBackup: 'Creando...',
      backupCreated: 'Copia de seguridad creada exitosamente',
      backupFailed: 'Error al crear la copia de seguridad',
      configurationOnlyInfo:
        'Estas copias de seguridad son solo para la configuración. Se excluyen los medios, las grabaciones de cámaras, las instantáneas de cámaras y el historial de valores registrados.',
      settingsSaved: 'Configuración de copias guardada',
      settingsLoadFailed: 'No se pudo cargar la configuración de copias de seguridad',
      settingsSaveFailed: 'No se pudo guardar la configuración de copias de seguridad',
      backupBeforeUpgrade: 'Crear copia antes de actualizar',
      backupBeforeUpgradeDesc:
        'Crea automáticamente una copia de seguridad de la configuración antes de instalar una actualización de software.',
      weeklyEnabled: 'Activar copias semanales',
      weeklyEnabledDesc: 'Crea una copia de seguridad de la configuración cada semana según la programación siguiente.',
      weeklyDay: 'Día de la copia',
      weeklyTime: 'Hora de la copia',
      keepBackupsCount: 'Copias conservadas en el servidor',
      keepBackupsCountHelp:
        'Los archivos locales más antiguos se eliminan automáticamente después de crear nuevas copias.',
      destinationSettings: 'Destinos de copia',
      networkCopyEnabled: 'Copiar la copia a una ubicación de red',
      networkCopyEnabledDesc:
        'Después de crear la copia local del servidor, se copia el mismo archivo a una carpeta de red o recurso compartido montado.',
      networkBackupPath: 'Ruta de copia en red',
      networkBackupPathPlaceholder: '\\\\nas\\otto\\backups o /mnt/backups/otto',
      networkBackupPathHelp:
        'Use una ruta UNC accesible o una carpeta montada. La retención local del servidor sigue aplicándose solo a la carpeta de copias del servidor.',
      cloudStorageTitle: 'Almacenamiento en la nube para suscriptores',
      cloudStorageDesc:
        'El almacenamiento en la nube para suscriptores usará el mismo paquete de copia de seguridad de configuración.',
      cloudStorageComingSoon:
        'La subida a la nube aún no está activa. Se habilitará cuando esté disponible el endpoint de copias para suscriptores.',
      localRetentionNote:
        'Las copias manuales usan el mismo paquete de configuración y siguen la misma política de retención local.',
      availableBackups: 'Copias de seguridad disponibles',
      noBackups: 'No hay copias de seguridad disponibles',
      download: 'Descargar',
      delete: 'Eliminar',
      deleteBackup: 'Eliminar copia de seguridad',
      confirmDeleteBackup: '¿Está seguro de que desea eliminar esta copia de seguridad?',
      backupDeleted: 'Copia de seguridad eliminada',
      restoreFromBackup: 'Restaurar desde copia de seguridad',
      warning:
        'Advertencia: Restaurar desde una copia de seguridad sobrescribirá todos los datos actuales. El sistema se reiniciará después de la restauración.',
      selectBackupFile: 'Seleccionar archivo de copia de seguridad para restaurar',
      restoringBackup: 'Restaurando...',
      restoring: 'Restaurando...',
      validating: 'Validando...',
      backupRestored: 'Copia de seguridad restaurada exitosamente',
      restoreFailed: 'Error al restaurar la copia de seguridad',
      confirmRestore: 'Esto sobrescribirá todos los datos actuales. ¿Continuar?',
      confirmRestoreTitle: 'Confirmar restauración',
      validationWarnings: 'Advertencias',
      backupInfo: 'Información de la copia de seguridad',
      backupVersion: 'Versión',
      backupDate: 'Fecha',
      incompatibleWarning:
        'El esquema de la base de datos no es compatible. Restaurar puede causar errores o pérdida de datos.',
      restoreInitiated: 'La restauración se inició. El sistema se reiniciará en breve.',
      filename: 'Nombre del archivo',
      created: 'Creado el',
      fileSize: 'Tamaño del archivo',
      downloadBackup: 'Descargar copia de seguridad',
      selectFile: 'Seleccionar archivo',
      deleteConfirm: '¿Eliminar {filename}?',
      downloadFailed: 'Error en la descarga',
      acceptedFormats: '.otto_backup, .ottohome_backup, .1hub_backup',
      restoreWizardStep1: 'Seleccionar archivo de copia de seguridad',
      restoreWizardStep2: 'Revisar copia de seguridad',
      restoreWizardStep3: 'Opciones de restauración',
      restoreWizardStep4: 'Confirmar restauración',
      restoreWizardCrossServerBanner: 'Esta copia de seguridad proviene de un servidor diferente.',
      restoreWizardCrossServerInfo:
        'Las contraseñas de usuario usan bcrypt y son portables. Los usuarios existentes pueden iniciar sesión con sus contraseñas. El servidor se reiniciará después de la restauración - tendrá que volver a iniciar sesión.',
      restoreWizardCreateRecoveryAdmin: 'Crear una cuenta de administrador de recuperación',
      restoreWizardRecoveryUsername: 'Nombre de usuario del administrador',
      restoreWizardRecoveryPassword: 'Contraseña del administrador',
      restoreWizardRecoveryAdminDesc:
        'Garantiza que al menos una cuenta de administrador funcione después de una restauración entre servidores.',
      restoreWizardPreserveHubId: 'Mantener la identidad actual del servidor',
      restoreWizardPreserveHubIdDesc: 'Evita sobrescribir el ID único de este servidor (recomendado).',
      restoreWizardSummaryDb: 'La base de datos será reemplazada por el contenido de la copia de seguridad.',
      restoreWizardSummaryFiles: 'Se restaurarán las subidas, los datos de Matter y las imágenes del sistema.',
      restoreWizardFinalWarning:
        'El servidor se reiniciará después de la restauración. Todos los usuarios conectados serán desconectados.',
      restoreWizardUserCount: '{count} cuentas de usuario en la copia de seguridad',
      restoreWizardTableCount: '{count} tablas de base de datos en la copia de seguridad',
      restoreWizardRestoreButton: 'Restaurar copia de seguridad',
      restoreWizardRestoring: 'Restaurando copia de seguridad...',
      restoreWizardUploading: 'Subiendo archivo de copia de seguridad...',
      restoreWizardRestoreComplete: '¡Restauración completada!',
      restoreWizardRestarting:
        'El sistema se está reiniciando. Será redirigido a la página de inicio de sesión en {seconds} segundos...',
      restoreWizardContinue: 'Continuar',
      restoreWizardBack: 'Atrás',
      restoreWizardValidating: 'Validando archivo de copia de seguridad...',
      restoreWizardValidationFailed: 'No se pudo validar el archivo de copia de seguridad.',
      valuesBackupTitle: 'Copia de valores',
      valuesBackupDesc:
        'Hace una copia del historial de valores del dispositivo (registros analógicos, registros de contadores y registros de valores). El archivo se descarga directamente y no se almacena en el servidor.',
      exportValuesBackup: 'Exportar copia de valores',
      exportingValues: 'Exportando copia de valores...',
      valuesRestoreTitle: 'Restaurar valores',
      valuesRestoreDesc: 'Restaure el historial de valores desde un archivo anterior de copia de valores.',
      valuesRestoreInfo:
        'Solo se importan las filas con valores de dispositivo coincidentes. Los valores de dispositivos inexistentes se omiten. Esto es una combinación - los datos existentes se conservan.',
      selectValuesBackup: 'Seleccionar archivo de copia de valores',
      importingValues: 'Importando copia de valores...',
      valuesRestoreResult: 'Valores restaurados: {inserted} insertados, {skipped} omitidos',
      valuesRestoreFailed: 'Error al restaurar la copia de valores',
    },

    settingsAgent: {
      configuration: 'Configuración',
      voice: 'Voz',
      enableAgent: 'Activar agente',
      enableAgentDesc:
        'Activa el agente de IA para que te ayude con comandos de voz y automatización del hogar inteligente.',
      wakeWord: 'Palabra de activación',
      wakeWordDesc: `Elige el comando de voz que activa el agente (por ej., "Hey ${brand.agentName}", "OK Nabu").`,
      voiceDesc: 'Selecciona tu voz preferida para las respuestas del agente.',
      autoListen: 'Escucha automática',
      autoListenDesc:
        'Inicia automáticamente la escucha después de que el agente responda, permitiendo una conversación continua.',
      confirmActions: 'Confirmar acciones',
      confirmActionsDesc: 'Solicita confirmación del usuario antes de ejecutar comandos automatizados.',
      settings: 'Ajustes',
      saving: 'Guardando...',
      voiceServices: 'Servicios de voz',
      browserServices: 'Navegador y automatización',
    },

    settingsDevices: {
      searchDevices: 'Buscar dispositivos...',
    },

    settingsDangerZone: {
      dangerZone: 'Zona peligrosa',
      deleteAllRooms: 'Eliminar todas las habitaciones',
      deleteAllRoomsDesc:
        'Elimina permanentemente todas las habitaciones y sus configuraciones. Esta acción no se puede deshacer.',
      deleteAllDevices: 'Eliminar todos los dispositivos',
      deleteAllDevicesDesc:
        'Elimina permanentemente todos los dispositivos y sus configuraciones. Esta acción no se puede deshacer.',
      deleteAllIntegrations: 'Eliminar todas las integraciones',
      deleteAllIntegrationsDesc: 'Desconecta y elimina todas las integraciones. Esta acción no se puede deshacer.',
      deleteAllScenes: 'Eliminar todas las escenas',
      deleteAllScenesDesc:
        'Elimina permanentemente todas las escenas y automatizaciones. Esta acción no se puede deshacer.',
      factoryReset: 'Restablecimiento de fábrica',
      warning: 'Advertencia: Esta acción no se puede deshacer.',
      resetting: 'Restableciendo...',
    },

    settingsLogs: {
      title: 'Registros del sistema',
      logRetention: 'Limpieza de registros',
      logRetentionDescription:
        'Eliminar automáticamente registros antiguos de las tablas de historial. Configure cuántos días conservar los datos.',
      valueLogsRetention: 'Registros de valores',
      scriptExecutionLogRetention: 'Registro de ejecución de scripts',
      presenceEventsRetention: 'Eventos de presencia',
      intercomCallsRetention: 'Llamadas de interfono',
      notificationsRetention: 'Notificaciones',
      eventsRetention: 'Eventos del sistema',
      sceneExecutionsRetention: 'Ejecuciones de escenas',
      messagesRetention: 'Mensajes',
      days: 'días',
      saveLogRetention: 'Guardar configuración de limpieza',
      cleanNow: 'Limpiar ahora',
      cleaning: 'Limpiando...',
      cleanNowConfirm: '¿Está seguro? Los registros antiguos se eliminarán permanentemente.',
      logRetentionSaved: 'Configuración de limpieza de registros guardada',
      logCleanupDone: 'Limpieza completada: {count} registros eliminados',
      saving: 'Guardando...',
    },

    settingsPlatform: {
      title: 'Plataforma',
      storage: 'Almacenamiento',
      dockerEngine: 'Motor',
      dockerCli: 'CLI',
      hardwareDescription: 'Perfil de hardware de la plataforma y estado de GPIO',
      testHardware: 'Probar hardware',
      hardwareTest: 'Prueba de hardware',
      hardwareTestDescription: 'Controle el LED del sistema y simule pulsaciones de botón para pruebas.',
      ledCurrent: 'Estado actual del LED',
      cancel: 'Cancelar',
      close: 'Cerrar',
      timeConfiguration: 'Configuración de hora',
      timezone: 'Zona horaria',
      loadingTimezones: 'Cargando zonas horarias...',
      ntpServers: 'Servidores NTP',
      ntpPlaceholder: 'ntp.example.com, pool.ntp.org',
      ntpDescription: 'Lista separada por comas de servidores NTP. Deje en blanco para servidores predeterminados.',
      saveTimeSettings: 'Guardar ajustes de hora',
      timeSettingsSaved: 'Ajustes de hora guardados correctamente',
      refresh: 'Actualizar',
      refreshing: 'Actualizando...',
      daemon: 'Daemon de plataforma',
      noUrlConfigured: 'No hay URL configurada',
      version: 'Versión',
      uptime: 'Tiempo de actividad',
      profile: 'Perfil',
      mode: 'Modo',
      mock: 'Simulado',
      hardwareMode: 'Hardware',
      hardware: 'Hardware',
      gpioConfigured: 'GPIO configurado',
      mockGpio: 'GPIO simulado',
      systemLed: 'LED del sistema',
      fan: 'Ventilador',
      capabilities: 'Capacidades',
      ledState: 'Estado del LED',
      apply: 'Aplicar',
      applying: 'Aplicando...',
      buttonPress: 'Pulsación de botón',
      buttonShort: 'Corta',
      buttonMedium: 'Media',
      buttonLong: 'Larga',
      buttonVeryLong: 'Muy larga',
      simulate: 'Simular',
      simulating: 'Simulando...',
      host: 'Host',
      hostname: 'Nombre del host',
      runtime: 'Entorno de ejecución',
      systemUptime: 'Tiempo activo del sistema',
      memory: 'Memoria',
      temperature: 'Temperatura',
      loadAverage: 'Carga media',
      dockerServices: 'Servicios Docker',
      available: 'Disponible',
      unavailable: 'No disponible',
      restart: 'Reiniciar',
      restarting: 'Reiniciando...',
      noContainersReported: 'No se informaron contenedores.',
      power: 'Energía',
      enabled: 'Activado',
      disabled: 'Desactivado',
      platform: 'Plataforma',
      command: 'Comando',
      requesting: 'Solicitando...',
      reboot: 'Reiniciar',
      shutdown: 'Apagar',
      events: 'Eventos',
      noEventsReported: 'No se informaron eventos.',
      loadingStatus: 'Cargando estado',
      notConfigured: 'No configurado',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      none: 'Ninguno',
      na: 'n/d',
      noStatus: 'Sin estado',
      of: 'de',
      running: 'en ejecución',
      unknown: 'Desconocido',
      ledBooting: 'Arrancando',
      ledHealthy: 'Correcto',
      ledDegraded: 'Degradado',
      ledOffline: 'Sin conexión',
      ledUpdating: 'Actualizando',
      ledError: 'Error',
      ledFactoryResetPending: 'Restablecimiento de fábrica pendiente',
      ledUnknown: 'Desconocido',
      confirmRestart: '¿Reiniciar {name}?',
      confirmReboot: '¿Reiniciar el host?',
      confirmShutdown: '¿Apagar el host?',
      se: {
        mode: 'Modo',
        type: 'Tipo',
        notFound: 'No encontrado',
        error: 'Error',
        title: 'Elemento seguro',
        description: 'Coprocesador criptográfico de hardware para la certificación Matter',
        serial: 'Número de serie',
        i2C: 'Bus I²C',
        provisioned: 'Aprovisionado',
        present: 'Presente',
        yes: '✓ Sí',
        no: 'Todavía no',
      },
      monitoring: {
        title: 'Monitorización del sistema',
        description:
          'Configure alertas para los umbrales de uso del disco. Se envían notificaciones a los administradores cuando se alcanzan los límites.',
        alerts: 'Alertas',
        diskWarning: 'Umbral de advertencia de disco',
        diskCritical: 'Umbral crítico de disco',
        save: 'Guardar ajustes de monitorización',
        diskUsage: 'Disco',
        offlineNotice:
          'El demonio de la plataforma está desconectado — los umbrales pueden ser valores locales de reserva y no se pueden guardar.',
      },
      network: {
        title: 'Red',
        description: 'Gestión de interfaces de red, WiFi y nombre del host',
        hostname: 'Nombre del host',
        gateway: 'Puerta de enlace predeterminada',
        gatewayShort: 'GW',
        dns: 'Servidores DNS',
        backend: 'Backend',
        default: 'Predeterminado',
        noInterfaces: 'No se han notificado interfaces.',
        connectSsid: 'WiFi SSID',
        ssidPlaceholder: 'Escanee o escriba un SSID',
        password: 'Contraseña',
        passwordPlaceholder: 'Contraseña WiFi',
        scan: 'Escanear',
        scanning: 'Escaneando...',
        connect: 'Conectar',
        connecting: 'Conectando...',
        saveHostname: 'Guardar nombre del host',
        resetDhcp: 'Restablecer el cable a DHCP',
        resetting: 'Restableciendo...',
        error: 'Error',
        confirmHostname:
          '¿Cambiar el nombre del host a {hostname}? Esto puede afectar el acceso mDNS (p. ej. {hostname}.local).',
        confirmResetDhcp: '¿Restablecer la interfaz cableada a DHCP? Esto puede cambiar la dirección IP.',
        configure: 'Configurar',
        static: 'IP estática',
        dhcp: 'DHCP',
        methodLabel: 'Método',
        ipConfig: 'Configuración IP',
        ipAddress: 'Dirección IP',
        prefix: 'Prefijo',
        dnsDescription: 'Servidores DNS separados por comas.',
        dhcpDescription: 'La interfaz obtendrá su dirección IP, puerta de enlace y DNS automáticamente de la red.',
        confirmStatic: '¿Establecer {iface} con una IP estática ({address})? La conexión se interrumpirá brevemente.',
        confirmDhcp: '¿Establecer {iface} en DHCP? La conexión se interrumpirá brevemente.',
        wifi: 'WiFi',
        wired: 'Cableado',
      },
      saving: 'Guardando...',
    },

    integrationCameras: {
      loadingState: 'Cargando cámaras...',
      camerasTab: 'Cámaras',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
      statusConnected: 'Conectado',
      statusReady: 'Listo',
      nvr: {
        serverSection: 'Compartir este hub (servidor NVR)',
        serverSectionHint: `Otros hubs ${brand.platformCompact} pueden conectarse aquí y ver las cámaras que les asigne.`,
        connectionInfo: 'Información de conexión',
        hubUrl: 'URL del hub (se usa como URL maestra en el otro hub)',
        newClient: 'Nuevo cliente',
        clientName: 'Nombre del cliente',
        createClient: 'Crear',
        enabled: 'Activado',
        disabled: 'Desactivado',
        clientsTitle: 'Clientes (otros hubs)',
        noClients: 'Aún no hay clientes — cree uno para obtener un token de un solo uso.',
        tokenTitle: 'Token de cliente de un solo uso',
        tokenHint: 'Pegue este token en el otro hub al añadir una fuente NVR. Solo se muestra una vez.',
        close: 'Cerrar',
        assignedCameras: 'Cámaras asignadas',
        saveAssignment: 'Guardar cámaras',
        lastSeen: 'Última vez visto',
        neverSeen: 'Nunca conectado',
        deleteClient: 'Eliminar',
        remoteClient: 'Remoto',
        sourceSection: 'Otros hubs (fuentes NVR)',
        sourceSectionHint:
          'Añada un hub que comparta cámaras con usted y luego importe sus cámaras. Las cámaras importadas son clientes ligeros — la grabación se realiza en el hub de origen.',
        addSource: 'Añadir fuente',
        sourceName: 'Nombre',
        masterUrl: 'URL del hub',
        masterUrlHint:
          'URL base del otro hub, p. ej. https://my-hub. Su API se sirve en /api — se aceptan tanto https://my-hub como https://my-hub/api.',
        token: 'Token',
        test: 'Probar',
        testOk: 'Accesible',
        testFail: 'Error',
        showCameras: 'Mostrar cámaras',
        importSelected: 'Importar seleccionadas',
        noRemoteCameras: 'Este hub aún no le ha asignado ninguna cámara.',
        remoteCamerasTitle: 'Cámaras disponibles en el hub de origen',
        importedTitle: 'Importadas en este hub',
        noImported: 'Aún no hay cámaras importadas.',
        remove: 'Eliminar',
        removeAll: 'Eliminar todo',
        sync: 'Sincronizar',
        adminRequired: 'Solo los administradores pueden gestionar el uso compartido de NVR.',
        error: 'No se pudo cargar la configuración de uso compartido NVR.',
      },
      nvrTab: 'NVR',
    },

    integrationDatapoints: {
      backButton: 'Volver a Integraciones',
      pageTitle: 'Puntos de datos',
      loadingState: 'Cargando puntos de datos...',
      statusConnected: 'Conectado',
      statusDisconnected: 'Desconectado',
      errorMessage: 'Error al cargar los puntos de datos',
    },

    integrationHomeAssistant: {
      entitiesTab: 'Entidades',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
      loadingState: 'Cargando datos de Home Assistant...',
      errorMessage: 'Error al conectar con Home Assistant',
    },
    settingsTorikApi: {
      cancel: 'Cancelar',
      title: 'Torik API',
      subtitle: 'API REST + WebSocket compatible con Home Assistant para herramientas externas y vínculos entre hubs.',
      refresh: 'Actualizar',
      running: 'Servidor de API en ejecución',
      stopped: 'Servidor de API detenido',
      port: 'Puerto',
      clients: 'Clientes conectados',
      tokenCount: 'Tokens activos',
      enabled: 'Activado',
      enabledToast: 'API de Torik activada',
      disabledToast: 'API de Torik desactivada',
      endpoints: 'Puntos de acceso',
      authHint: `Autentíquese con "Authorization: Bearer ***" (WebSocket: {'{'}"type":"auth","access_token":"<token>"{'}'}).`,
      tokensTitle: 'Tokens de acceso',
      tokensHint: 'Tokens de portador de larga duración. Cree uno aquí y péguelo en el hub que se vincula.',
      newToken: 'Nuevo token',
      noTokens: 'Aún no hay tokens de API.',
      lastUsed: 'último uso',
      never: 'nunca',
      active: 'Activo',
      disabled: 'Desactivado',
      delete: 'Eliminar',
      deleteConfirm: '¿Eliminar este token? Los clientes que lo usen perderán el acceso de inmediato.',
      deleted: 'Token eliminado',
      createTitle: 'Crear token de API',
      tokenCreatedTitle: 'Token creado',
      tokenName: 'Nombre del token',
      tokenNamePlaceholder: 'p. ej. hub secundario, Node-RED',
      creating: 'Creando...',
      create: 'Crear',
      copyWarning: 'Copie este token ahora — solo se muestra una vez.',
      copy: 'Copiar',
      copied: 'Token copiado',
      copyFailed: 'Error al copiar',
      done: 'Listo',
    },

    integrationKNX: {
      statusDisabled: 'Desactivado',
      statusConnected: 'Conectado',
      statusDisconnected: 'Desconectado',
      deleteAllDevicesButton: 'Eliminar todos los dispositivos',
      loadingState: 'Cargando datos KNX...',
      settingsTab: 'Configuración',
      datapointsTab: 'Puntos de datos',
      devicesTab: 'Dispositivos',
      groupMonitorTab: 'Monitor de grupo',
      logsTab: 'Registros',
      deleteModalTitle: 'Eliminar todos los dispositivos KNX',
      deleteConfirmMessage:
        '¿Está seguro de que desea eliminar todos los dispositivos KNX? Esta acción no se puede deshacer.',
      deleteConfirmLabel: 'Para confirmar, escriba "DELETE" a continuación:',
      deleteConfirmPlaceholder: 'Escriba DELETE para confirmar',
      cancelButton: 'Cancelar',
      deleteConfirmButton: 'Eliminar todos los dispositivos',
      deletingState: 'Eliminando dispositivos...',
      errorMessage: 'Error al procesar la solicitud KNX',
    },

    remoteSupport: {
      selectIntegration: 'Seleccionar integración KNX',
      selectIntegrationPlaceholder: 'Elegir integración KNX...',
      knxRemoteSupport: 'Soporte remoto KNX',
      tpuartTitle: 'Controlador TP-UART requerido',
      tpuartDesc:
        'El uso compartido de la interfaz KNX a través del controlador TP-UART estará disponible cuando el demonio de plataforma lo admita.',
      remoteUsers: 'Usuarios de soporte remoto',
      remoteUsersDesc:
        'Administre usuarios que pueden proporcionar soporte remoto. Agregue usuarios por correo electrónico y configure límites de tiempo de acceso.',
      addUserByEmail: 'Agregar usuario por correo',
      emailPlaceholder: "usuario{'@'}ejemplo.es",
      addUser: 'Agregar',
      adding: 'Agregando...',
      remove: 'Eliminar',
      removing: 'Eliminando...',
      installerRole: 'Instalador',
      noEmail: 'Sin correo',
      noRemoteUsers: 'No hay usuarios de soporte remoto.',
      editAccess: 'Editar',
      day: 'Día',
      days: 'Días',
      daysAccess: 'días de acceso',
      perSession: 'por sesión',
      unlimited: 'Ilimitado',
      unlimitedAccess: 'Acceso ilimitado',
      confirmRemoveUser: '¿Eliminar a {name} del soporte remoto? Su cuenta se convertirá en usuario normal.',
      accessDaysPrompt: 'Duración de acceso (días, 0 = ilimitado):',
      accessHoursPrompt: 'Horas máx. por sesión:',
      newSession: 'Nueva sesión de soporte',
      selectUser: 'Seleccionar usuario',
      selectUserPlaceholder: 'Elegir usuario...',
      timeWindow: 'Duración de sesión',
      createSession: 'Crear sesión',
      creating: 'Creando...',
      endSession: 'Finalizar sesión',
      ending: 'Finalizando...',
      activeSessions: 'Sesiones activas',
      installerLabel: 'Instalador',
      timeRemaining: 'Tiempo restante',
      expired: 'Expirado',
      justNow: 'justo ahora',
      ago: 'atrás',
      hour: 'Hora',
      hours: 'Horas',
      minutes: 'Minutos',
      send: 'Enviar',
      messagePlaceholder: 'Escribir mensaje...',
      noMessages: 'Aún no hay mensajes.',
      issueReport: 'Informe de problema / Chat',
      issueReportDesc: 'Envíe un mensaje al usuario de soporte sobre el problema en el que se está trabajando.',
      viewChat: 'Chat',
      cannotAddSelf: 'No puede añadirse a sí mismo. Esto le bloquearía el acceso a su cuenta de administrador.',
    },

    integrationMatter: {
      loadingState: 'Cargando datos Matter...',
      settingsTab: 'Configuración',
      nodesTab: 'Nodos',
      devicesTab: 'Dispositivos',
      logsTab: 'Registros',
      errorMessage: 'Error al conectar con la red Matter',
    },

    integrationMatterBridge: {
      brideDeviceCount: 'Dispositivos puenteados',
      loadingState: 'Cargando datos de Matter Bridge...',
      bridgedDevicesTab: 'Dispositivos puenteados',
      commissioningTab: 'Puesta en servicio',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
      errorMessage: 'Error al conectar con Matter Bridge',
    },

    integrationComputers: {
      subtitle: `Ordenadores con el agente ${brand.agentName}, emparejados con este hub.`,
      integrationLabel: `Ordenadores ${brand.platformCompact}`,
      refreshAction: 'Actualizar',
      addComputerAction: 'Añadir ordenador',
      totalLabel: 'Ordenadores',
      onlineLabel: 'En línea',
      offlineLabel: 'Sin conexión',
      onlineState: 'En línea',
      offlineState: 'Sin conexión',
      connectedState: 'Conectado',
      noComputersState: 'Activado, sin ordenadores',
      disabledState: 'Desactivado',
      unknownState: 'Desconocido',
      loadingState: 'Cargando ordenadores…',
      emptyTitle: 'Aún no hay ordenadores',
      emptyMessage: `Instale el agente ${brand.agentName} en un ordenador y emparéjelo con este hub para controlarlo desde ${brand.platformName}.`,
      hostLabel: 'Host',
      platformLabel: 'Plataforma',
      agentVersionLabel: 'Agente',
      lastSeenLabel: 'Última vez visto',
      neverSeen: 'nunca',
      memoryLabel: 'Memoria',
      diskLabel: 'Disco',
      tempLabel: 'Temperatura de CPU',
      uptimeLabel: 'Tiempo activo',
      rebootAction: 'Reiniciar',
      sleepAction: 'Suspender',
      shutdownAction: 'Apagar',
      wakeAction: 'Despertar',
      wakeSendAction: 'Enviar paquete de activación',
      wakeHint:
        'El hub envía el paquete de activación desde su propia red (WOL debe estar activado en la BIOS del ordenador).',
      removeAction: 'Eliminar',
      refreshNodeAction: 'Actualizar estado',
      macPlaceholder: 'AA:BB:CC:DD:EE:FF',
      loadError: 'No se pudieron cargar los ordenadores',
      refreshFailed: 'Error al actualizar',
      powerSent: 'Comando de encendido enviado a',
      powerFailed: 'Error en el comando de encendido',
      wakeSent: 'Paquete de activación enviado',
      wakeFailed: 'Error en Wake-on-LAN',
      removeConfirmTitle: '¿Eliminar ordenador?',
      removeConfirmMessage: 'Esto desvincula el ordenador de este hub y elimina su dispositivo.',
      removed: 'Ordenador eliminado',
      removeFailed: 'Error al eliminar',
      addDialogTitle: 'Añadir ordenador',
      addDialogSubtitle: `Genere un código de emparejamiento e instale el agente ${brand.agentName} en el ordenador con ese código. El código caduca a los 15 minutos.`,
      nodeNamePlaceholder: 'p. ej. PC de estudio',
      generateTokenAction: 'Generar código de emparejamiento',
      copyTokenAction: 'Copiar',
      pairingCodeLabel: 'Código de emparejamiento',
      installCommandTitle: 'En el ordenador, ejecute:',
      doneAction: 'Hecho',
      copied: 'Código de emparejamiento copiado',
      copyFailed: 'Error al copiar',
      pairingFailed: 'No se pudo generar el código de emparejamiento',
      macLabel: 'MAC',
      hubAddressLabel: 'Dirección del hub',
      hubAddressHint:
        'La dirección que usarán los ordenadores para llegar a este hub. La lista muestra las direcciones de red de este hub — elija la que el ordenador pueda alcanzar (p. ej. la misma red) o introduzca una dirección personalizada. En producción (https) la dirección del hub está preseleccionada.',
      commandCopied: 'Comando copiado',
      computersTab: 'Ordenadores',
      devicesTab: 'Dispositivos',
      customHubAddressAction: 'Dirección personalizada...',
      customHubAddressPlaceholder: 'http://192.168.1.72',
      selectHubAddressHint: 'Elija una dirección de hub arriba para ver los comandos de instalación.',
    },
    integrationTouchPanels: {
      integrationName: 'Paneles táctiles',
      statusDisabled: 'Desactivado',
      statusConnected: 'Conectado',
      statusReady: 'Listo',
      loadingState: 'Cargando integración de paneles táctiles...',
      panelsTab: 'Paneles',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
      refreshAction: 'Actualizar',
      panelsAction: 'Paneles',
      settingsAction: 'Configuración',
      logsAction: 'Registros',
      totalPanelsLabel: 'Paneles registrados',
      onlinePanelsLabel: 'En línea ahora',
      offlinePanelsLabel: 'Sin conexión',
      sleepingPanelsLabel: 'En reposo',
      pairingStatusLabel: 'Estado de emparejamiento',
      pairedPanelsLabel: 'Emparejados',
      pendingPanelsLabel: 'Emparejamiento pendiente',
      lastActivityLabel: 'Actividad más reciente',
      noActivityLabel: 'Sin actividad reciente',
      noActivityDescription: 'Ningún panel ha reportado actividad todavía',
      attentionLabel: 'Requiere atención',
      justNowLabel: 'justo ahora',
      minutesAgoLabel: 'hace {count} min',
      hoursAgoLabel: 'hace {count} h',
      daysAgoLabel: 'hace {count} d',
      errorMessage: 'Error al cargar la integración de paneles táctiles',
    },

    integrationZigbee: {
      loadingState: 'Cargando datos Zigbee...',
      nodesTab: 'Nodos',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      errorMessage: 'Error al conectar con la red Zigbee',
    },

    integrationZWave: {
      loadingState: 'Cargando datos Z-Wave...',
      nodesTab: 'Nodos',
      networkTab: 'Red',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      errorMessage: 'Error al conectar con la red Z-Wave',
    },
    integrationWled: {
      segmentsTab: 'Segmentos',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
      loadingState: 'Cargando...',
      errorMessage: 'Error al cargar la integración',
    },

    integrationHue: {
      lightsTab: 'Luces',
      groupsTab: 'Grupos',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
    },
    integrationUnifi: {
      networkTab: 'Red',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
    },
    integrationSomfy: {
      gatewayTab: 'Puerta de enlace',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
    },
    integrationSynology: {
      statusTab: 'Estado',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
    },
    integrationMediaPlayers: {
      playersTab: 'Reproductores',
      devicesTab: 'Dispositivos',
      sourcesTab: 'Fuentes',
      settingsTab: 'Configuración',
    },
    integrationSonos: {
      settingsTab: 'Configuración',
      playersTab: 'Reproductores',
      devicesTab: 'Dispositivos',
    },
    integrationSpotify: {
      settingsTab: 'Configuración',
      devicesTab: 'Dispositivos',
    },

    panelPairing: {
      title: `${brand.agentName} Panel Táctil`,
      subtitle: 'Configuración del dispositivo',
      discoverTitle: `Encuentre su hub ${brand.agentName}`,
      discoverDescription: `Buscando en su red local un hub ${brand.agentName}...`,
      scanningStatus: 'Escaneando red...',
      noHubsFound: 'No se encontraron hubs automáticamente.',
      manualEntryHint: 'Ingrese la dirección del hub manualmente a continuación.',
      manualEntryLabel: 'O ingrese manualmente',
      ipAddressPlaceholder: 'Dirección IP del hub',
      portPlaceholder: 'Puerto',
      connectButton: 'Conectar',
      rescanButton: '↻ Escanear de nuevo',
      backButton: 'Atrás',
      connectedToLabel: 'Conectado a',
      pairingMethodTitle: 'Emparejar este dispositivo',
      pairingRequirement: `Un administrador debe generar un código de emparejamiento en la aplicación ${brand.agentName}.`,
      enterPinButton: 'Ingresar PIN',
      pinEntryTitle: 'Ingrese el PIN de emparejamiento',
      pinEntryDescription: `Ingrese el PIN de 6 dígitos que se muestra en la aplicación de administración ${brand.agentName}.`,
      pairDeviceButton: 'Emparejar dispositivo',
      pairingInProgress: 'Emparejando...',
      invalidPinError: 'PIN inválido. Por favor, intente de nuevo.',
      cameraAccessDenied: 'Acceso a la cámara denegado. Por favor, habilite los permisos de la cámara.',
      invalidQrError: 'Código QR inválido. Por favor, intente de nuevo.',
      exitPinTitle: 'Establecer PIN de salida',
      exitPinDescription: 'Elija un PIN de 4 dígitos para salir del modo panel más tarde.',
      skipButton: 'Omitir',
      pairedSuccess: '¡Dispositivo emparejado!',
      connectingMessage: 'Conectando a su panel...',
    },

    playPairing: {
      title: `${brand.agentName} Play`,
      subtitle: 'Configuración del dispositivo',
      discoverTitle: `Encuentre su hub ${brand.agentName}`,
      discoverDescription: `Buscando en su red local un hub ${brand.agentName}...`,
      scanningStatus: 'Escaneando red...',
      noHubsFound: 'No se encontraron hubs automáticamente.',
      manualEntryHint: 'Ingrese la dirección del hub manualmente a continuación.',
      manualEntryLabel: 'O ingrese manualmente',
      ipAddressPlaceholder: 'Dirección IP del hub',
      portPlaceholder: 'Puerto',
      connectButton: 'Conectar',
      rescanButton: '↻ Escanear de nuevo',
      backButton: 'Atrás',
      connectedToLabel: 'Conectado a',
      pairingMethodTitle: 'Emparejar este dispositivo',
      pairingRequirement: `Un administrador debe generar un código de emparejamiento en la aplicación ${brand.agentName}.`,
      enterPinOption: 'Ingresar PIN',
      enterPinDescription: 'Ingrese el código de 6 dígitos que se muestra en la aplicación de administración',
      scanQrOption: 'Escanear código QR',
      scanQrDescription: 'Escanee el código QR que se muestra en la aplicación de administración',
      pinEntryTitle: 'Ingrese el PIN de emparejamiento',
      pinEntryDescription: `Ingrese el PIN de 6 dígitos que se muestra en la aplicación de administración ${brand.agentName}.`,
      pairDeviceButton: 'Emparejar dispositivo',
      pairingInProgress: 'Emparejando...',
      scanQrTitle: 'Escanear código QR',
      scanQrInstruction: `Apunte la cámara al código QR en la aplicación de administración ${brand.agentName}.`,
      scanningAutoStatus: 'Escaneando automáticamente...',
      exitPinTitle: 'Establecer PIN de salida',
      exitPinDescription: 'Elija un PIN de 4 dígitos para salir del modo Play más tarde.',
      confirmPinButton: 'Confirmar PIN',
      reenterPinInstruction: 'Vuelva a ingresar su PIN para confirmar',
      pinMismatchError: 'Los PIN no coinciden. Intente de nuevo.',
      skipButton: 'Omitir',
      pairedSuccess: '¡Dispositivo emparejado!',
      pairedDescription: `Este dispositivo ahora está vinculado a su hub ${brand.agentName} como dispositivo Play.`,
      startPlayModeButton: 'Iniciar modo Play',
      invalidPinError: 'PIN inválido. Por favor, intente de nuevo.',
      cameraAccessDenied: 'Acceso a la cámara denegado. Por favor, habilite los permisos de la cámara.',
      invalidQrError: 'Código QR inválido. Por favor, intente de nuevo.',
    },

    gallery: {
      pageTitle: 'Fotos',
      emptyTitle: 'Aún no hay fotos',
      emptyDescription: 'Suba fotos y videos para comenzar su galería personal en la nube.',
      noAlbumTitle: 'Aún no hay álbumes',
      noAlbumDescription: 'Cree un álbum para agrupar y compartir sus fotos.',
      noAlbumItems: 'Aún no hay fotos en este álbum',
      newAlbum: 'Nuevo álbum',
      takePhoto: 'Cámara',
      uploadPhotos: 'Subir',
      createAlbumTitle: 'Crear álbum',
      selectPhotos: 'Seleccionar',
      uploadProgress: 'Subiendo',
      dropZoneText: 'Suelte fotos y videos aquí',
      uploadStatus: 'archivo',
      uploadStatusPlural: 'archivos',
      sharedBadge: 'Compartido',
      publicBadge: 'Público',
    },

    reminders: {
      pageTitle: 'Recordatorios',
      addButton: 'Nuevo recordatorio',
      upcomingTab: 'Próximos',
      completedTab: 'Completados',
      emptyUpcoming: 'No hay recordatorios próximos.',
      emptyCompleted: 'No hay recordatorios completados.',
      createReminderTitle: 'Nuevo recordatorio',
      editReminderTitle: 'Editar recordatorio',
      titleLabel: 'Título',
      titlePlaceholder: 'Comprar comida',
      notesLabel: 'Notas',
      notesPlaceholder: 'Detalles adicionales...',
      notesOptional: '(opcional)',
      dateTimeLabel: 'Fecha y hora',
      repeatLabel: 'Repetir',
      repeatNone: 'Ninguna',
      repeatDaily: 'Diario',
      repeatWeekly: 'Semanal',
      repeatMonthly: 'Mensual',
      repeatWeekdays: 'Días laborables (Lun–Vie)',
      cancelButton: 'Cancelar',
      saveButton: 'Guardar',
      createButton: 'Crear recordatorio',
    },

    timers: {
      pageTitle: 'Temporizadores',
      addButton: 'Nuevo temporizador',
      emptyState: 'Aún no hay temporizadores. Toque Nuevo temporizador para crear uno.',
      createTimerTitle: 'Nuevo temporizador',
      labelLabel: 'Etiqueta',
      labelPlaceholder: 'Agua para pasta',
      durationLabel: 'Duración',
      hoursLabel: 'Horas',
      minutesLabel: 'Minutos',
      secondsLabel: 'Segundos',
      soundLabel: 'Sonido',
      totalLabel: 'total',
      startButton: 'Iniciar',
      pauseButton: 'Pausar',
      resetButton: 'Restablecer',
      deleteButton: 'Eliminar',
      deleteConfirm: '¿Eliminar este temporizador?',
      cancelButton: 'Cancelar',
      createButton: 'Crear',
      creatingLabel: 'Creando...',
      statusIdle: 'inactivo',
      statusRunning: 'en curso',
      statusPaused: 'pausado',
      statusCompleted: 'completado',
    },
    integrationESPHome: {
      entitiesTab: 'Nodos y entidades',
      devicesTab: 'Dispositivos',
      settingsTab: 'Configuración',
      logsTab: 'Registros',
      loadingState: 'Cargando datos de ESPHome...',
      errorMessage: 'Error al cargar la integración ESPHome',
    },
    integrationTorik: {
      entitiesTab: 'Importar',
      devicesTab: 'Dispositivos',
      settingsTab: 'Vínculo',
      logsTab: 'Registros',
      loadingState: 'Cargando el vínculo del hub Torik...',
      entitiesTitle: 'Dispositivos remotos',
      entitiesHint:
        'Busque dispositivos en el hub vinculado e impórtelos como dispositivos locales. Los valores se mantienen sincronizados y los comandos se reenvían.',
      discover: 'Buscar dispositivos',
      discovering: 'Buscando...',
      searchPlaceholder: 'Buscar por nombre o ID de entidad...',
      selectAll: 'Seleccionar todo',
      selected: 'seleccionados',
      importCount: 'Importar',
      imported: 'Importados',
      emptyState: 'Pulse Buscar dispositivos para obtener los dispositivos del hub vinculado.',
      importTitle: 'Importar dispositivos remotos',
      roomMapping: 'Asignar habitaciones remotas a habitaciones locales:',
      remoteRoom: 'Habitación remota:',
      noRoom: '— Sin habitación (coincidencia automática por nombre) —',
      created: 'Creados',
      skipped: 'Omitidos',
      errors: 'Errores',
      close: 'Cerrar',
      cancel: 'Cancelar',
      import: 'Importar',
      importing: 'Importando...',
      linkTitle: 'Vínculo del hub',
      linkHint: 'Conexión con el hub Torik vinculado (su API Torik).',
      test: 'Probar conexión',
      testing: 'Probando...',
      sync: 'Sincronizar ahora',
      syncing: 'Sincronizando...',
      syncDone: 'Sincronización completada',
      reconnect: 'Reconectar',
      reconnecting: 'Reconectando...',
      reconnectDone: 'Reconectado',
      cleanup: 'Eliminar todos los dispositivos importados',
      cleaning: 'Eliminando...',
      cleanupConfirm: '¿Eliminar todos los dispositivos importados de este hub? Esta acción no se puede deshacer.',
      cleanupDone: 'Dispositivos eliminados',
      peerUrl: 'URL del par',
      peerVersion: 'Versión del par',
      token: 'Token de acceso',
    },
    // The guest experience of the demo house (card `t_803e86a4`) — see `en.ts`.
    demoGuest: {
      pill: 'Invitado',
      pillNamed: 'Invitado · {name}',
      hint: 'Esta es una casa de demostración: un día entero se simula en minutos.',
      dismiss: 'Descartar',
    },
  },
  shell: {
    home: 'Inicio',
    // The floor for a tab nothing else names (card t_99f5ed79) — see `en.ts`.
    newTab: 'Nueva pestaña',
    closeTab: 'Cerrar pestaña',
    alertError: 'Error',
    alertWarning: 'Aviso',
    alertNotice: 'Alerta',
    player: 'Reproductor',
    previous: 'Anterior',
    play: 'Reproducir',
    pause: 'Pausa',
    mute: 'Silenciar',
    unmute: 'Activar sonido',
    volume: 'Volumen',
    // The main process's native popups (card t_99f5ed79): the tab context menu,
    // the app menu, and the connection-info dialog — see `en.ts` for the note.
    openInNewWindow: 'Abrir en una ventana nueva',
    connectionInfo: 'Información de conexión',
    reload: 'Recargar',
    fullscreen: 'Pantalla completa',
    close: 'Cerrar',
    launcher: 'Lanzador',
    services: 'Servicios',
    miniPlayerWindow: 'Ventana del mini reproductor',
    rebuildBar: 'Reconstruir la barra del sistema',
    settings: 'Ajustes',
    quit: 'Salir',
    info: {
      target: 'Destino',
      endpoint: 'Extremo',
      hubId: 'ID del hub',
      hubName: 'Nombre del hub',
      state: 'Estado',
      route: 'Ruta',
      connected: 'conectado',
      disconnected: 'desconectado',
      secure: 'seguro',
      cloudHub: 'hub en la nube {id}',
      managedInLauncher: 'Las credenciales y los servidores guardados se gestionan en el lanzador.',
      ok: 'Aceptar',
      tab: 'Pestaña',
    },
  },
  connectionLost: {
    title: 'Conexión perdida',
    session: '{hub}: tu sesión ha caducado. Vuelve a conectarte para seguir trabajando en esta pestaña.',
    offline: '{hub} no responde. Comprueba la red y vuelve a conectarte.',
    thisServer: 'Este servidor',
    reconnect: 'Reconectar',
    reconnecting: 'Reconectando...',
    close: 'Cerrar',
  },
  api: {
    // What a failed hub call actually means (`utils/apiFailure.ts`), so a surface
    // that only catches the error can still name the cause instead of one sentence
    // that fits every failure — read as `t(apiFailureSentenceKey(error))`.
    failure: {
      unreachable: 'No se pudo alcanzar el hub, así que no se pudo leer esta configuración.',
      refused: 'Esta ventana no ha iniciado sesión en el hub, por lo que rechazó esta configuración.',
      wrong_target: 'La respuesta no vino del servicio de este hub, así que no se pudo leer esta configuración.',
      hub_failed: 'El hub informó de un error al leer esta configuración.',
    },
  },
  hub: {
    // Adopting an unclaimed hub from the app (HEADLESS-HUB-ONBOARDING.md
    // D3/D4/D5): the confirm sheet, the sticker QR and every refusal the hub
    // can answer with — one sentence each, in every shipped locale.
    adopt: {
      title: 'Adoptar este hub',
      intro:
        'Este hub está en tu red y aún no tiene propietario. Al adoptarlo se registra en tu cuenta de Torik y pasas a ser su propietario.',
      notOffered:
        'Este hub no está esperando ser adoptado, así que aquí no hay nada que adoptar. No se ha enviado nada — si tu cuenta de Torik está en este hub, ábrelo desde tus servidores.',
      hubLabel: 'Hub',
      accountLabel: 'Cuenta',
      roleLabel: 'Tu rol',
      roleOwner: 'Propietario',
      noCode: 'No hay nada que escribir: tu cuenta es la credencial.',
      noAccount: 'Sin sesión iniciada',
      // Una sesión cuyo nombre de cuenta esta hoja no conoce: el dispositivo SÍ
      // tiene sesión, y la fila no puede decir lo contrario (tarjeta t_a53c5f61).
      accountSignedIn: 'Sesión iniciada',
      signInRequired: 'Inicia sesión en tu cuenta de Torik para adoptar este hub.',
      signIn: 'Iniciar sesión',
      signingIn: 'Abriendo…',
      signInFailed: 'No se pudo iniciar el proceso de sesión. Inténtalo de nuevo.',
      confirm: 'Adoptar este hub',
      working: 'Adoptando…',
      retry: 'Reintentar',
      cancel: 'Cancelar',
      doneTitle: '{hub} es tuyo',
      doneBody: 'Está registrado en {account} y este dispositivo ya está emparejado con él.',
      // La variante de la frase anterior sin nombre de cuenta: `{account}` no
      // puede llevar una frase en todos los idiomas, así que este caso se reformula.
      doneBodySignedIn: 'Está registrado en tu cuenta de Torik y este dispositivo ya está emparejado con él.',
      doneWhere: 'Lo encontrarás en tus servidores, en la página de inicio.',
      roleLine: 'Tienes el rol {role} en este hub.',
      continue: 'Continuar',
      scanLead: '¿Un hub recién sacado de la caja? Escanea el código impreso en su caja: así lo adoptas en tu cuenta.',
      linkWrongHub: 'Ese código pertenece a un hub distinto del que responde en esa dirección. No se ha adoptado nada.',
      linkUnverified:
        'El hub de esa dirección no confirmó cuál es, así que no se ha adoptado nada. Comprueba que el hub esté encendido y sea accesible.',
      rateLimited: 'Demasiados intentos desde este dispositivo. Espera un minuto y vuelve a intentarlo.',
      notOnHubNetwork:
        'El hub lo ha rechazado: este dispositivo no está en la red del propio hub. Conéctate a la misma red que el hub (no por VPN) y vuelve a intentarlo.',
      alreadyClaimed: 'Este hub ya tiene propietario. Pídele que te invite.',
      invalidCloudToken: 'Se ha rechazado la sesión de tu cuenta de Torik. Inicia sesión de nuevo y vuelve a adoptar.',
      invalidDevice: 'El hub ha rechazado la clave de este dispositivo. Inténtalo de nuevo.',
      cloudUnreachable:
        'El hub no ha podido contactar con la nube de Torik, así que no se ha registrado. Comprueba la conexión a internet del hub y vuelve a intentarlo.',
      hubIdentityUnavailable: 'El hub aún no puede leer su propia identidad. Espera un momento y vuelve a intentarlo.',
      registrationFailed:
        'La nube no ha querido registrar el hub en tu cuenta. Vuelve a intentarlo o contacta con soporte.',
      unsupported: 'Este hub no admite la adopción (software antiguo).',
      unreachable: 'No ha respondido nada en esa dirección. Comprueba que el hub esté encendido y en esta red.',
      unproven:
        'El dispositivo de esa dirección no pudo demostrar que es este hub. No se ha adoptado nada y tu cuenta no se le ha enviado.',
      malformed: 'El hub respondió sin adoptar. No se ha cambiado nada.',
      refused: 'El hub ha rechazado la adopción.',
      cardAction: 'Hub sin propietario: ¿adoptarlo?',
      cardHint:
        'Nadie es propietario de {hub} todavía. Al adoptarlo se registra en tu cuenta de Torik y pasas a ser su propietario.',
      cardSignIn: 'Inicia sesión en tu cuenta de Torik para adoptar {hub}.',
      badgeWaiting: 'Esperando adopción',
      localPageHint: '{hub} todavía no tiene propietario: búscalo con la búsqueda de servidores locales.',
      localPageAction: 'Buscar servidores locales',
      addressLabel: 'Dirección',
      loopbackOnly:
        'Este dispositivo solo puede alcanzar este hub en {address}, su propia máquina. Un hub nunca acepta una adopción desde sí mismo (por ahí llegan también las llamadas tunelizadas), así que adóptalo desde otro dispositivo de la misma red.',
      tokenRetired:
        'El hub ya no acepta el inicio de sesión de una cuenta para la adopción: se requiere una licencia. Actualice la aplicación e inténtelo de nuevo.',
      licenceUsed: 'Esa licencia de adopción ya se usó. No se cambió nada: inténtelo de nuevo para obtener una nueva.',
      licenceExpired: 'La licencia de adopción caducó antes de que el hub pudiera usarla. Inténtelo de nuevo.',
      licenceMismatch: 'Esa licencia se emitió para otro hub. No se adoptó nada.',
      licenceInvalid:
        'El hub no pudo verificar la licencia firmada por la nube. Actualice la aplicación y el hub e inténtelo de nuevo.',
      licenceRequired:
        'El hub esperaba una licencia de adopción y no se envió ninguna. Actualice la aplicación e inténtelo de nuevo.',
      licenceRefused: 'La nube se negó a emitir una licencia de adopción para este hub.',
      licenceUnknownHub:
        'La nube no pudo identificar este hub, así que no emitió ninguna licencia. Deje que el hub se conecte a internet una vez e inténtelo de nuevo.',
      licenceAlreadyOwned: 'Otra cuenta de Torik ya es propietaria de este hub. Pida a su propietario que le invite.',
      licenceUnavailable:
        'La nube no puede emitir licencias de adopción en este momento. Inténtelo más tarde o contacte con soporte.',
      licenceUnauthorized: 'Se rechazó la sesión de su cuenta de Torik. Inicie sesión de nuevo y adopte.',
      licenceUnreachable:
        'No se pudo alcanzar la nube de Torik, así que no se pudo emitir ninguna licencia. Compruebe la conexión a internet de este dispositivo e inténtelo de nuevo.',
      licenceMalformed: 'La nube respondió sin licencia. No se adoptó nada: inténtelo de nuevo.',
      password: {
        title: 'Establecer una contraseña local',
        intro:
          'Una contraseña para {hub} mantiene esta casa en marcha sin internet, y permite que cualquiera en la casa inicie sesión aunque la nube de Torik no esté disponible.',
        label: 'Contraseña',
        hint: 'Al menos 8 caracteres.',
        confirmLabel: 'Confirma la contraseña',
        mismatch: 'Las dos contraseñas no coinciden.',
        currentLabel: 'Contraseña actual',
        save: 'Guardar contraseña',
        saving: 'Guardando…',
        skip: 'Ahora no',
        done: 'Contraseña local guardada: esta casa ahora funciona sin internet.',
        noSessionNote:
          'Este dispositivo no ha iniciado sesión en el hub, así que no se pudo establecer una contraseña local. Abra el hub y establézcala allí.',
        resolving: 'Comprobando este servidor…',
        noAddress:
          'Este servidor no tiene una dirección a la que este dispositivo pueda llamar, así que no se puede establecer una contraseña local desde aquí.',
        noAccount: 'Inicia sesión en tu cuenta Torik para establecer una contraseña local en este hub.',
        notThisAccount:
          'Este hub pertenece a otra cuenta Torik, así que esta cuenta no puede establecer su contraseña local.',
        noAnswer:
          'Nadie respondió en la dirección de este hub, así que no se pudo establecer una contraseña local. Comprueba que el hub esté encendido y en esta red.',
        close: 'Cerrar',
        required: 'Introduzca una contraseña.',
        tooShort: 'La contraseña es demasiado corta: al menos 8 caracteres.',
        tooLong: 'La contraseña es demasiado larga (72 bytes como máximo).',
        wrongCurrent: 'Esa no es la contraseña que esta cuenta ya tiene en el hub.',
        notPermitted: 'Solo un administrador puede establecer esta contraseña.',
        noSuchUser: 'El hub no conoce esa cuenta.',
        noSession: 'Este dispositivo no ha iniciado sesión en el hub, así que no puede establecer una contraseña.',
        invalidCredentials: 'Usuario o contraseña incorrectos.',
        disabled: 'Esa cuenta está deshabilitada en este hub.',
        outsideWindow:
          'Esta cuenta solo puede iniciar sesión dentro del horario configurado en el hub. Pide al propietario del hub que mueva la ventana.',
        tooManyAttempts: 'Demasiados intentos. Espere un minuto e inténtelo de nuevo.',
        unreachable: 'Nadie respondió en esa dirección. Compruebe que el hub esté encendido y en esta red.',
        refused: 'El hub rechazó establecer esa contraseña.',
      },
    },
    join: {
      title: 'Unirse a este hub',
      intro:
        'Este hub está en tu red y tu cuenta de Torik ya tiene un rol en él. Al unirte se vincula tu cuenta aquí y este dispositivo podrá usar el hub — sin código y sin contraseña.',
      hubLabel: 'Hub',
      accountLabel: 'Cuenta',
      roleLabel: 'Tu rol',
      roleReading: 'Comprobando…',
      roleUnknown: 'Aún no se conoce',
      noCode:
        'Nada que escribir — tu cuenta es la credencial. El código en la pantalla del hub es para invitados, contratistas y paneles sin teclado.',
      noAccount: 'Sin sesión',
      signInRequired: 'Inicia sesión en tu cuenta de Torik para unirte a este hub.',
      confirm: 'Unirse a este hub',
      working: 'Uniéndose…',
      retry: 'Intentar de nuevo',
      cancel: 'Cancelar',
      doneTitle: 'Te has unido a {hub}',
      doneBody: '{account} ya está vinculada a este hub y este dispositivo puede usarlo.',
      roleLine: 'Tu rol en este hub es {role}.',
      continue: 'Continuar',
      noMatchingUser:
        'Este hub aún no tiene un usuario con tu correo electrónico. Pide al propietario del hub que invite esta dirección y vuelve a intentarlo.',
      notAMember:
        'Tu cuenta de Torik no tiene ningún rol en este hub. Pide al propietario del hub que invite esta dirección.',
      userDisabled: 'Esta cuenta está deshabilitada en este hub. Pide al propietario del hub que la habilite.',
      outsideLoginWindow:
        'Esta cuenta solo puede iniciar sesión dentro del horario configurado en el hub. Pide al propietario del hub que mueva la ventana.',
      invalidCloudToken: 'Se rechazó la sesión de tu cuenta de Torik. Inicia sesión de nuevo y reintenta.',
      deviceInUse: 'Este dispositivo ya está registrado con otra cuenta. Revócalo allí primero o usa otro dispositivo.',
      alreadyClaimed:
        'Este hub acaba de tomar este dispositivo — la solicitud ya se había usado. Vuelve a abrir el hub.',
      expired: 'La solicitud caducó antes de que el hub la tomara. Inténtalo de nuevo.',
      grantKeyMissing:
        'La nube de Torik no puede firmar el permiso para este dispositivo ahora mismo. Inténtalo en un momento.',
      unknownDevice: 'El hub no conoce este registro. Inténtalo de nuevo.',
      notApproved: 'El hub aún no ha registrado el permiso para este dispositivo. Inténtalo en un momento.',
      invalidProof: 'El hub rechazó la clave de este dispositivo. Inténtalo de nuevo.',
      rateLimited: 'Demasiados intentos desde este dispositivo. Espera un minuto y vuelve a intentarlo.',
      unreachable: 'Nada respondió en esta dirección. Comprueba que el hub esté encendido y en esta red.',
      malformed: 'El hub respondió sin vincular este dispositivo. No se cambió nada.',
      refused: 'El hub rechazó la solicitud. No se cambió nada.',
    },

    // Un hub que esta app no puede abrir (tarjeta `t_bfe0edc9`): la frase que dice de quién

    // credencial y donde vive su propia forma de entrar (utils/hubOpenFallback.ts).

    open: {
      title: 'No se pudo abrir {hub}',

      dismiss: 'Cerrar',

      openLocalPage: 'Buscar servidores locales',

      openServers: 'Servidores',

      needsCredential:
        'Las páginas de este hub necesitan una credencial que este dispositivo no tiene. No se ha enviado ni cambiado nada.',

      // Una frase por cada forma en que un hub permanece cerrado (`HUB_OPEN_FAILURES`).

      failure: {
        no_credential:
          'Este dispositivo aún no tiene credencial para {hub}. Tu cuenta de Torik lo abre desde aquí — sin código y sin contraseña.',

        credential_refused:
          '{hub} no aceptó la credencial que tenía este dispositivo, así que se descartó. Ábrelo desde aquí con tu cuenta de Torik — no hace falta ningún código.',

        no_cloud_session: 'Inicia sesión en tu cuenta de Torik para abrir {hub}.',

        no_lan_address: '{hub} no anunció ninguna dirección a la que este dispositivo pueda llamar.',

        no_account_identity:
          'Tu cuenta de Torik aún no tiene {hub}. Adóptalo aquí, o pide a su propietario que invite esta dirección.',

        unreachable: 'Nadie respondió en {address}. Comprueba que {hub} esté encendido y en esta red.',
        permission_held:
          'El navegador retiene esta solicitud: este sitio aún no tiene permiso para acceder a tu red local. Permite el acceso a la red local y vuelve a intentarlo, o abre {hub} a través de la nube.',

        not_this_hub: 'Algo respondió en {address}, y no es {hub}.',

        not_proven:
          '{hub} respondió en {address} y no pudo demostrar que posee la clave que fijó tu cuenta. No se ha enviado nada.',

        cannot_prove: 'No se pudo preguntar al dispositivo en {address} si es {hub}.',

        refused: '{hub} rechazó la solicitud de tu cuenta de Torik — pide a su propietario que invite esta dirección.',

        // El rechazo propio de la **nube** (`services/cloudSessionRefusal.ts`,
        // plan FLOOR-PLAN-AND-PLAN-EDITOR.md §3.2/D3): el servidor es solo local.
        // No es un fallo — es su estado, dicho una vez.
        remote_access_not_licensed:
          'Este servidor está configurado en modo solo acceso local — puedes acceder a él desde su propia red. El acceso remoto está incluido en un plan de servidor de pago.',
      },
    },
    // El **alta** (plan `LOCAL-SERVER-ONBOARDING-JOURNEY.md` §3/C2–C3, decisiones
    // del propietario §7 Q1/Q2/Q4): lo que abre la página Local para un servidor
    // que pertenece a esta cuenta y cuyo plan lo mantiene en su propia red.
    // Primero el estado, luego la frase honesta sobre el plan de pago y por
    // último la contraseña local (`hub.adopt.password.*` — el paso que comparte
    // con la adopción). Aquí no se vende nada: sin lista de precios y sin compra,
    // el plan vive en la cuenta.
    onboard: {
      title: 'Configura este servidor',
      intro:
        'Este servidor funciona en tu propia red. Aquí están el estado de su licencia y la contraseña que lo mantiene accesible sin internet.',
      licenceLabel: 'Licencia',
      reading: 'Leyendo…',
      remoteTitle: 'El acceso remoto requiere un plan de pago',
      remoteBody:
        'El acceso remoto a este servidor forma parte de un plan de pago. Gestiona el plan en tu cuenta de Torik.',
      accountLink: 'Gestionar el plan en tu cuenta',
      accountHint: 'Abre tu cuenta de Torik en el navegador.',
      openButton: 'Configurar {hub}',
      doneTitle: '{hub} está configurado',
      doneSkipped: 'Listo. Puedes establecer la contraseña local cuando quieras desde esta página.',
      noAddress:
        'Este servidor no ha anunciado ninguna dirección a la que este dispositivo pueda conectarse, así que la contraseña local no se puede establecer desde aquí. Ábrelo antes desde tus servidores.',
    },
  },
  // WLED integration — the two tabs read these (WLEDSegmentsTab.vue, WLEDSettingsTab.vue)
  wled: {
    tabs: {
      segmentsTitle: 'Segmentos',
      segmentsSubtitle:
        'Cada segmento activo de WLED se puede importar como dispositivo de luz (incluye efectos, paletas y preajustes).',
    },
    discover: 'Detectar',
    discovering: 'Detectando...',
    creating: 'Creando...',
    createDevices: 'Crear dispositivos de luz',
    loading: 'Cargando segmentos...',
    emptyTitle: 'No se han encontrado segmentos',
    emptyMessage:
      'Pulsa Detectar para leer la distribución de segmentos del controlador WLED. Se crea un dispositivo por segmento: un controlador estándar de una sola tira tiene un segmento que cubre todos los LED.',
    createHint: 'Crear un dispositivo de luz por segmento (predeterminado: todos).',
    loadFailed: 'No se pudieron cargar los segmentos',
    createFailed: 'No se pudieron crear los dispositivos',
    discoveryFailed: 'La detección ha fallado',
    alreadyImported:
      'Se han omitido los segmentos ya importados. Las luces nuevas aparecen en Habitaciones / Dispositivos.',
    colName: 'Segmento',
    colType: 'Tipo',
    colColor: 'Color',
    colEffect: 'Efecto',
    colPalette: 'Paleta',
    colStatus: 'Estado',
    online: 'En línea',
    offline: 'Sin conexión',
    settings: {
      title: 'Configuración',
      subtitle: 'Ajustes de conexión del controlador WLED. Una integración gestiona un controlador.',
      connected: 'Conectada',
      disconnected: 'Desconectada',
      noUrl: 'No hay URL del controlador configurada',
      enabled: 'Activado',
      disabled: 'Desactivada',
      reconnecting: 'Reconectando...',
      reconnect: 'Reconectar',
      boardTitle: 'Controlador',
      refresh: 'Actualizar',
      name: 'Nombre',
      version: 'Firmware',
      leds: 'LED',
      channels: 'Canales',
      url: 'URL del controlador',
      scanning: 'Buscando...',
      findOnNetwork: 'Buscar en la red',
      urlHint: 'Dirección IP o nombre de host del controlador WLED, o usa Buscar en la red.',
      apiKey: 'Clave de API',
      apiKeyPlaceholder: 'Opcional',
      hide: 'Ocultar',
      show: 'Mostrar',
      apiKeyHint: 'Solo es necesario si la seguridad de WLED está activada.',
      pollInterval: 'Intervalo de sondeo (segundos)',
      pollHint: 'Actualización de reserva cuando el WebSocket no está disponible.',
      testing: 'Probando...',
      test: 'Probar conexión',
      saved: 'Ajustes guardados.',
      saving: 'Guardando...',
      save: 'Guardar ajustes',
      errorUpdate: 'No se pudo actualizar la integración',
      errorReconnect: 'La reconexión ha fallado',
      errorConnection: 'La conexión ha fallado',
      errorSave: 'No se pudieron guardar los ajustes',
    },
  },
} as const;
